export const Icon1h = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2746 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M138.6,2747.9c.3,0,.5.1.7.4s.2.5,0,.8l-2.2,5.5c-.1.3-.4.5-.7.5s-.6-.1-.8-.4l-.3-.4c-1.3,1.6-2,3.6-2,5.7,0,5,4,9,9,9s9-4,9-9,.4-.8.8-.8h3.3c.5,0,.8.4.8.8,0,7.7-6.3,14-14,14s-14-6.3-14-14,1.5-7.2,4.1-9.8l-.6-.8c-.2-.2-.2-.6,0-.8.1-.3.4-.4.7-.4h5.9l.3-.3Z" />
          <path d="M141.3,2763.5h-1.6v-5.7l-1,.9-.9-1,1.9-1.6h1.5v7.4h.1Z" />
          <path d="M143.8,2758.6c.2-.3.5-.5.8-.6.3-.2.7-.2,1.1-.2s1.1.1,1.5.4c.4.2.7.6.9,1s.3.9.3,1.5v2.9h-1.5v-2.9c0-.4,0-.6-.1-.9,0-.2-.2-.4-.4-.5s-.5-.2-.8-.2-.6,0-.8.2c-.2.1-.4.3-.6.6-.1.2-.2.5-.2.9v2.8h-1.5v-8.2h1.5v3.3h-.2Z" />
          <path d="M155,2755.8c.4-.1.9.1,1,.6.1.4-.1.9-.6,1l-3.2.8c-.4.1-.9-.1-1-.6-.1-.4.1-.9.6-1l3.2-.8Z" />
          <path d="M153.5,2752.7c.4-.2.9-.1,1.1.3.2.4,0,.9-.3,1.1l-2.8,1.6c-.4.2-.9,0-1.1-.3s0-.9.3-1.1l2.8-1.6Z" />
          <path d="M151.2,2750.1c.3-.3.8-.3,1.2,0,.3.3.3.8,0,1.2l-2.3,2.3c-.3.3-.8.3-1.2,0-.3-.3-.3-.8,0-1.2l2.3-2.3Z" />
          <path d="M148.4,2748.2c.2-.4.7-.5,1.1-.3.4.2.5.7.3,1.1l-1.6,2.8c-.2.4-.7.5-1.1.3-.4-.2-.5-.7-.3-1.1l1.6-2.8Z" />
          <path d="M146.1,2746.5c.4.1.7.6.6,1l-.8,3.2c-.1.4-.6.7-1,.6-.4-.1-.7-.6-.6-1l.8-3.2c.1-.4.6-.7,1-.6Z" />
          <path d="M142.5,2746c.5,0,.8.4.8.8v3.3c0,.5-.4.8-.8.8s-.8-.4-.8-.8v-3.3c0-.4.4-.8.8-.8Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Icon2to3h = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2794 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M155.7,2807.2h-3.3c-.5,0-.8.4-.8.8,0,5-4,9-9,9s-9-4-9-9,.7-4.1,2-5.7l.3.4c.2.2.5.4.8.4s.6-.2.7-.5l2.2-5.5v-.8c0-.2-.4-.3-.7-.4h-5.9c-.3.1-.6.3-.7.6-.1.3-.1.6,0,.8l.6.8c-2.6,2.6-4.1,6.1-4.1,9.8,0,7.7,6.3,14,14,14s14-6.3,14-14-.4-.8-.8-.8h-.3Z" />
          <path d="M150.3,2803.5c.2.4.7.5,1.1.3l2.8-1.6c.4-.2.5-.7.3-1.1-.2-.4-.7-.5-1.1-.3l-2.8,1.6c-.4.2-.5.7-.3,1.1Z" />
          <path d="M147,2800.2c.4.2.9,0,1.1-.3l1.6-2.8c.2-.4,0-.9-.3-1.1-.4-.2-.9,0-1.1.3l-1.6,2.8c-.2.4,0,.9.3,1.1Z" />
          <path d="M142.5,2799c.5,0,.8-.4.8-.8v-3.3c0-.4-.4-.8-.8-.8s-.8.4-.8.8v3.3c0,.5.4.8.8.8Z" />
          <path d="M151.2,2805.7c.1.5.6.7,1,.6l3.2-.8c.4-.1.7-.6.6-1-.1-.4-.6-.7-1-.6l-3.2.8c-.4.1-.7.6-.6,1Z" />
          <path d="M148.9,2801.6c.3.3.8.3,1.2,0l2.3-2.3c.3-.3.3-.8,0-1.2-.3-.3-.8-.3-1.2,0l-2.3,2.3c-.3.3-.3.8,0,1.2Z" />
          <path d="M144.8,2799.3c.4.1.9-.1,1-.6l.8-3.2c.1-.4-.1-.9-.6-1-.4-.1-.9.1-1,.6l-.8,3.2c-.1.4.1.9.6,1Z" />
          <path d="M144.5,2811h-1.2v-6.5h1.2v2.6c.2-.2.4-.4.6-.5.2-.1.5-.2.9-.2s.8,0,1.1.3c.3.2.5.5.7.8.1.3.2.7.2,1.2v2.3h-1.2v-3c0-.2-.2-.3-.4-.4-.2,0-.4-.1-.6-.1s-.5,0-.7.2c-.2.1-.3.2-.4.4-.1.2-.2.4-.2.7v2.2h0Z" />
          <path d="M140,2807.5h.3c.3,0,.6,0,.8-.2.2-.1.3-.3.3-.4s0-.4-.3-.5c-.2-.2-.4-.2-.8-.2s-.5,0-.7.2c-.2.1-.3.3-.3.5l-1.2-.2c0-.3.1-.6.3-.9s.5-.4.8-.6c.3-.1.7-.2,1.2-.2s.9,0,1.2.2c.3.1.6.4.8.6.2.2.3.5.3.8s0,.5-.2.7c-.1.2-.3.4-.5.5.3.2.5.3.6.6.1.2.2.5.2.8s0,.7-.3.9c-.2.3-.5.5-.8.7-.4.2-.8.3-1.4.3s-.9,0-1.2-.2c-.3-.1-.6-.3-.8-.6s-.3-.5-.4-.9l1.2-.2c0,.2.2.3.4.5.2.1.5.2.8.2s.5,0,.7-.1c.2,0,.3-.2.4-.3,0-.1.1-.3.1-.4,0-.2-.1-.4-.3-.5s-.5-.2-.9-.2h-.3v-.9h0Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Age = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3754 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M154.1,3766.3c-.8-5.9-5.4-10.4-11.2-10.6-1,0-1.8.8-1.8,1.7,0,1.6,1.6,1.8,2,1.8.7,0,1.2-.4,1.2-.7s-.5-.7-1.2-.7-.6-.3-.6-.6.3-.6.6-.6c1.3,0,2.3.8,2.3,1.9s-1,1.9-2.3,1.9c-1.9,0-3.2-1.2-3.2-2.9s.2-1.1.5-1.5c-4.9,1-8.7,5.2-9.4,10.4-1.4.3-2.5,1.6-2.5,3.1s1.4,3.2,3.2,3.2h0c1.7,4.4,5.9,7.6,10.8,7.6s9-3.1,10.8-7.6h0c1.8,0,3.2-1.4,3.2-3.2s-1-2.8-2.5-3.1h0ZM139.1,3768.5c0,.6-.5,1.2-1.2,1.2s-1.2-.5-1.2-1.2v-1.2c0-.6.5-1.2,1.2-1.2s1.2.5,1.2,1.2v1.2ZM145.2,3774.3c-.8.4-1.7.6-2.6.6s-1.8-.2-2.6-.6c-.3-.1-.4-.5-.2-.8s.5-.4.8-.2c1.3.7,2.8.7,4.1,0,.3-.1.6,0,.8.2.1.3,0,.6-.2.8h-.1ZM148.4,3768.5c0,.6-.5,1.2-1.2,1.2s-1.2-.5-1.2-1.2v-1.2c0-.6.5-1.2,1.2-1.2s1.2.5,1.2,1.2v1.2Z" />
      </g>
    </g>
  </svg>
);

export const AllDay = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="130.5 2892 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M154.2,2903.3l-3-3v-4.2c0-.5-.4-.9-.9-.9h-4.2l-3-3c-.4-.4-1-.4-1.3,0l-3,3h-4.2c-.5,0-.9.4-.9.9v4.2l-3,3c-.4.4-.4,1,0,1.3l3,3v4.2c0,.5.4.9.9.9h4.2l3,3c.4.4,1,.4,1.3,0l3-3h4.2c.5,0,.9-.4.9-.9v-4.2l3-3c.4-.4.4-1,0-1.3Z" />
      </g>
    </g>
  </svg>
);

export const AnyWeather = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3658 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M137.9,3666.1c1.2-1.9,3.4-3.2,5.8-3.2,3.7,0,6.7,2.9,6.9,6.5h.2c3.1,0,5.7,2.6,5.7,5.7s-2.6,5.7-5.7,5.7h-14.8c-4.1,0-7.5-3.4-7.5-7.5s3.3-7.5,7.5-7.5,1.3,0,1.9.2h0ZM146.4,3671.7c.4-.4.4-1,0-1.4s-1-.4-1.4,0l-3.8,3.8-1.9-1.9c-.4-.4-1-.4-1.3,0-.4.4-.4,1,0,1.4l2.5,2.6c.4.4,1,.4,1.3,0l4.5-4.5h0Z" fillRule="evenodd" />
      </g>
    </g>
  </svg>
);

export const Archieve = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1642 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M131,1653.5h1.2v11.1c0,.5.2,1.1.6,1.5.4.4.9.6,1.5.6h16.5c.6,0,1.1-.2,1.5-.6s.6-.9.6-1.5v-11.1h1.2c.5,0,1-.2,1.3-.5s.5-.8.5-1.3v-4.6c0-.5-.2-1-.5-1.3-.3-.4-.8-.5-1.3-.5h-23c-.5,0-1,.2-1.3.5s-.5.8-.5,1.3v4.6c0,.5.2,1,.5,1.3s.8.5,1.3.5h-.1ZM147.2,1659.4c0,.2,0,.5-.3.7-.2.2-.4.3-.7.3h-7.5c-.2,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7v-.7c0-.2.1-.5.3-.7s.4-.3.7-.3h7.5c.2,0,.5,0,.7.3.2.2.3.4.3.7v.7ZM130.5,1647.1c0,0,0-.3.2-.4,0,0,.2-.2.4-.2h23c.1,0,.3,0,.4.2,0,0,.2.2.2.4v4.6c0,0,0,.3-.2.4,0,0-.2.2-.4.2h-23c-.1,0-.3,0-.4-.2,0,0-.2-.2-.2-.4v-4.6Z" />
  </svg>
);

export const Archieve_______ = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1786 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M144.8,1801c.1,0,.3,0,.4.2.1,0,.2.2.2.4v.4c0,0,0,.3-.2.4-.1,0-.2.2-.4.2h-4.5c-.1,0-.3,0-.4-.2-.1,0-.2-.2-.2-.4v-.4c0,0,0-.3.2-.4.1,0,.2-.2.4-.2h4.5Z" fill="#69757c" />
          <path d="M149.4,1794.7h.2v3h-14.2v-3h14Z" fill="#69757c" />
          <path d="M142.5,1786c7.7,0,14,6.3,14,14s-6.3,14-14,14-14-6.3-14-14,6.3-14,14-14ZM135.6,1794c-.3,0-.6,0-.8.3-.2.2-.3.5-.3.7v2.6c0,.3.1.5.3.7s.5.3.8.3h.7v6.2c0,.3.1.6.4.8.2.2.6.3.9.3h9.9c.3,0,.7,0,.9-.3.2-.2.4-.5.4-.8v-6.2h.7c.3,0,.6,0,.8-.3.2-.2.3-.5.3-.7v-2.6c0-.3-.1-.5-.3-.7s-.5-.3-.8-.3h-13.9Z" fill="#69757c" fillRule="evenodd" />
        </g>
      </g>
    </g>
  </svg>
);

export const ArrowL = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 346 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M155.2,358.8h-22.4l6.7-6.6c.1-.1.2-.3.3-.4,0-.2.1-.3.1-.5v-.5c0-.2-.2-.3-.3-.4s-.3-.2-.4-.3h-.5c-.2,0-.3,0-.5.1-.2,0-.3.2-.4.3l-8.9,8.8c-.2.2-.4.6-.4.9s.1.6.4.9l8.9,8.8c.2.2.6.4.9.4s.7-.1.9-.4c.2-.2.4-.5.4-.9s-.1-.6-.4-.9l-6.7-6.6h22.4c.3,0,.7-.1.9-.4.2-.2.4-.6.4-.9s-.1-.6-.4-.9c-.2-.2-.6-.4-.9-.4h-.1Z" fill={color} />
      </g>
    </g>
  </svg>
);

export const ArrowR = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 394 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M129.8,406.8h22.4l-6.7-6.6c-.1-.1-.2-.3-.3-.4,0-.2-.1-.3-.1-.5v-.5c0-.2.2-.3.3-.4s.3-.2.4-.3h.5c.2,0,.3,0,.5.1.2,0,.3.2.4.3l8.9,8.8c.2.2.4.6.4.9s-.1.6-.4.9l-8.9,8.8c-.2.2-.6.4-.9.4s-.7-.1-.9-.4c-.2-.2-.4-.5-.4-.9s.1-.6.4-.9l6.7-6.6h-22.4c-.3,0-.7-.1-.9-.4-.2-.2-.4-.6-.4-.9s.1-.6.4-.9c.2-.2.6-.4.9-.4h.1Z" fill={color} />
      </g>
    </g>
  </svg>
);

export const Auto = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3178 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M131.4,3197.5c-.8-1.7-1.2-3.5-1.2-5.3,0-6.8,5.5-12.4,12.4-12.4s5.3.9,7.4,2.5l-2,.3c-.4,0-.8.5-.7.9,0,.4.5.8.9.7l3.8-.5c.4,0,.8-.5.7-.9l-.5-3.9c0-.4-.5-.8-.9-.7-.4,0-.8.5-.7.9l.2,1.7c-2.4-1.7-5.2-2.7-8.2-2.7s-7.3,1.4-9.9,4.1c-2.6,2.6-4.1,6.2-4.1,9.9s.5,4.1,1.4,6c.2.4.7.6,1.1.4.4-.2.6-.7.4-1.1h0Z" />
          <path d="M150.1,3191l.4-.2c.4-.2.5-.7.3-1.1l-1.9-3.3c-.2-.4-.7-.5-1.1-.3l-.4.2c-.9.5-2.1-.1-2.1-1.2v-.5c0-.4-.4-.8-.8-.8h-3.8c-.5,0-.8.4-.8.8v.5c0,1.1-1.2,1.8-2.1,1.2l-.4-.2c-.4-.2-.9,0-1.1.3l-1.9,3.3c-.2.4,0,.9.3,1.1l.4.2c.9.6.9,1.9,0,2.4l-.4.2c-.4.2-.5.7-.3,1.1l1.9,3.3c.2.4.7.5,1.1.3l.4-.2c.9-.5,2.1.1,2.1,1.2v.5c0,.5.4.8.8.8h3.8c.5,0,.8-.4.8-.8v-.5c0-1.1,1.2-1.8,2.1-1.2l.4.2c.4.2.9,0,1.1-.3l1.9-3.3c.2-.4,0-.9-.3-1.1l-.4-.2c-.9-.5-.9-1.9,0-2.4ZM142.6,3195.3c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1,3.1,1.4,3.1,3.1-1.4,3.1-3.1,3.1Z" />
          <path d="M155.2,3186.1c-.2-.4-.7-.6-1.1-.4-.4.2-.6.7-.4,1.1.8,1.7,1.2,3.5,1.2,5.3,0,6.8-5.5,12.4-12.4,12.4s-5.3-.9-7.4-2.5l2-.3c.4,0,.8-.5.7-.9,0-.4-.5-.8-.9-.7l-3.9.5c-.4,0-.8.5-.7.9l.5,3.8c0,.4.5.8.9.7.4,0,.8-.5.7-.9l-.2-1.7c2.4,1.7,5.2,2.7,8.2,2.7s7.3-1.5,9.9-4.1c2.6-2.7,4.1-6.2,4.1-9.9s-.5-4.1-1.4-6h.2Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Base_Black = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 202 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M154.5,216c0-6.6-5.4-12-12-12s-12,5.4-12,12,5.4,12,12,12v2c-7.7,0-14-6.3-14-14s6.3-14,14-14,14,6.3,14,14-6.3,14-14,14v-2c6.6,0,12-5.4,12-12Z" />
      </g>
    </g>
  </svg>
);

export const Base_Green = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 250 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M154.5,264c0-6.6-5.4-12-12-12s-12,5.4-12,12,5.4,12,12,12v2c-7.7,0-14-6.3-14-14s6.3-14,14-14,14,6.3,14,14-6.3,14-14,14v-2c6.6,0,12-5.4,12-12Z" fill="#006475" />
      </g>
    </g>
  </svg>
);

export const Bus = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2986 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M154.1,2993.2h-.5v-1c0-2.8-2.2-5-5-5h-12c-2.8,0-5,2.2-5,5v1h-.5c-1.4,0-2.5,1.1-2.5,2.5v2.5c0,.6.4,1,1,1s1-.4,1-1v-2.5c0-.3.2-.5.5-.5h.5v10c0,1.6.8,3.1,2,4h0v2c0,1.1.9,2,2,2h1c1.1,0,2-.9,2-2v-1h8v1c0,1.1.9,2,2,2h1c1.1,0,2-.9,2-2v-2h0c1.2-.9,2-2.3,2-4v-10h.5c.3,0,.5.2.5.5v2.5c0,.6.4,1,1,1s1-.4,1-1v-2.5c0-1.4-1.1-2.5-2.5-2.5ZM136.1,3007.2c-.8,0-1.5-.7-1.5-1.5s.7-1.5,1.5-1.5,1.5.7,1.5,1.5-.7,1.5-1.5,1.5ZM149.1,3007.2c-.8,0-1.5-.7-1.5-1.5s.7-1.5,1.5-1.5,1.5.7,1.5,1.5-.7,1.5-1.5,1.5ZM151.6,2998.7c0,1-.7,1.8-1.7,2-2.4.4-4.8.5-7.3.5s-5-.2-7.3-.5c-1-.1-1.7-1-1.7-2v-5.5c0-1.1.9-2,2-2h14c1.1,0,2,.9,2,2v5.5Z"/>
      </g>
    </g>
  </svg>
);

export const Catefory = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3706 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M155.9,3724.4v5.5c0,1.8-1.5,3.3-3.3,3.3h-5.5c-1.8,0-3.3-1.5-3.3-3.3v-5.5c0-1.8,1.5-3.3,3.3-3.3h5.5c1.8,0,3.3,1.5,3.3,3.3ZM138.1,3706.6h-5.5c-1.8,0-3.3,1.5-3.3,3.3v5.5c0,1.8,1.5,3.3,3.3,3.3h5.5c1.8,0,3.3-1.5,3.3-3.3v-5.5c0-1.8-1.5-3.3-3.3-3.3ZM149.8,3718.8c3.4,0,6.1-2.7,6.1-6.1s-2.7-6.1-6.1-6.1-6.1,2.7-6.1,6.1,2.7,6.1,6.1,6.1ZM138.1,3721h-5.5c-1.8,0-3.3,1.5-3.3,3.3v5.5c0,1.8,1.5,3.3,3.3,3.3h5.5c1.8,0,3.3-1.5,3.3-3.3v-5.5c0-1.8-1.5-3.3-3.3-3.3Z" />
  </svg>
);

export const Chec_Stroke = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 874 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M148.7,883.6c.4.4.4,1.1,0,1.5l-7.3,7.3c-.4.4-1.1.4-1.5,0l-3.5-3.5c-.4-.4-.4-1.1,0-1.5s1.1-.4,1.5,0l2.7,2.7,6.6-6.6c.4-.4,1.1-.4,1.5,0h0ZM156.5,888c0,7.7-6.3,14-14,14s-14-6.3-14-14,6.3-14,14-14,14,6.3,14,14ZM154.3,888c0-6.5-5.3-11.8-11.8-11.8s-11.8,5.3-11.8,11.8,5.3,11.8,11.8,11.8,11.8-5.3,11.8-11.8Z" />
      </g>
    </g>
  </svg>
);

export const Check = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1594 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M147.8,1601.4c-.5-.6-1.4-.6-2,0l-10.3,10.2-4.5-4.7c-.5-.6-1.4-.6-2,0-.6.5-.6,1.4,0,2h0l5.5,5.7c.3.3.6.4,1,.4h0c.4,0,.7,0,1-.4l11.4-11.2c.5-.5.6-1.4,0-2h0Z" />
          <path d="M142.9,1614.6c.3.3.6.4,1,.4h0c.4,0,.7,0,1-.4l11.4-11.2c.5-.6.5-1.5-.1-2-.5-.5-1.3-.5-1.8,0l-10.3,10.2-.4-.4c-.5-.6-1.4-.6-2,0-.6.5-.6,1.4,0,2h0l1.4,1.4h-.2Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Check_Button = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1834 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M142.5,1834h0c7.7,0,14,6.3,14,14h0c0,7.7-6.3,14-14,14h0c-7.7,0-14-6.3-14-14h0c0-7.7,6.3-14,14-14Z" fill="#006475" />
      <path d="M149.2,1843.3c-.4-.4-1-.4-1.4,0l-7.4,7.3-3.2-3.3c-.4-.4-1-.4-1.4,0s-.4,1,0,1.4h0l3.9,4c.2.2.4.3.7.3h0c.3,0,.5,0,.7-.3l8.1-8c.4-.4.4-1,0-1.4h0Z" fill="#fff" />
    </g>
  </svg>
);

export const ChevronDown = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1306 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M143.3,1322.7l4-4c.2-.2.3-.4.3-.7s-.1-.5-.3-.7-.4-.3-.7-.3-.5,0-.7.3l-3.3,3.3-3.3-3.3c-.2-.2-.4-.3-.7-.3s-.5,0-.7.3c-.2.2-.3.4-.3.7s0,.5.3.7l4,4c.2.2.4.3.7.3s.5,0,.7-.3Z" />
  </svg>
);

export const Chevron_L = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1210 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M139.9,1223.3l4-4c.2-.2.4-.3.7-.3s.5,0,.7.3c.2.2.3.4.3.7s0,.5-.3.7l-3.3,3.3,3.3,3.3c.2.2.3.4.3.7s-.1.5-.3.7-.4.3-.7.3-.5,0-.7-.3l-4-4c-.2-.2-.3-.4-.3-.7s.1-.5.3-.7Z" />
  </svg>
);

export const Chevron_R = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1162 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M145.3,1175.3l-4-4c-.2-.2-.4-.3-.7-.3s-.5,0-.7.3c-.2.2-.3.4-.3.7s0,.5.3.7l3.3,3.3-3.3,3.3c-.2.2-.3.4-.3.7s.1.5.3.7.4.3.7.3.5,0,.7-.3l4-4c.2-.2.3-.4.3-.7s-.1-.5-.3-.7Z" />
  </svg>
);

export const ChevronUp = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1258 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M143.3,1269.3l4,4c.2.2.3.4.3.7s-.1.5-.3.7-.4.3-.7.3-.5,0-.7-.3l-3.3-3.3-3.3,3.3c-.2.2-.4.3-.7.3s-.5,0-.7-.3c-.2-.2-.3-.4-.3-.7s0-.5.3-.7l4-4c.2-.2.4-.3.7-.3s.5,0,.7.3Z" />
  </svg>
);

export const Clear = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 442 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M149.7,443.7c.8-1.5,2.6-2.1,4.1-1.3,1.5.8,2.1,2.6,1.3,4.1l-3.2,6c-.1.2-.3.5-.5.7.9,1.3,1.1,2.9.6,4.4-.1.3-.3.7-.4,1.1,0,.2-.2.2-.4.2l-10.2-5.3c-.2,0-.2-.3,0-.4.3-.3.5-.6.7-.8,1.1-1.3,2.8-2,4.4-2h0c0-.1,3.4-6.6,3.4-6.6h.2Z" />
      <path d="M139.7,454.9h-.3c-.6.6-1.3,1.1-1.8,1.4-2,1.2-3.6,1.6-4.6,1.8-.6,0-1.1.5-1.3,1s-.2,1.2.2,1.7c.5.6,1.3,1.3,2.4,2.2h.2c.8-.2,1.6-.3,2.3-.7.2-.1.5-.3.9-.6.4-.3,1-.3,1.3,0,.3.4.3.9,0,1.3-.5.4-.9.7-1.3.9-.3.1-.6.3-.9.4-.2,0-.3.4,0,.5.6.4,1.2.8,1.8,1.2s.7.4,1,.6h.3c.5-.3.9-.7,1.2-1,.8-.7,1.4-1.5,1.9-2.4.3-.4.8-.6,1.3-.3.4.2.6.8.3,1.2-.6,1-1.4,2-2.3,2.8-.2.1-.3.3-.5.4s-.1.4,0,.5c1.1.5,2.1.9,2.7,1.1.9.3,2,0,2.5-.8.7-1,1.9-2.9,2.9-5.3.3-.6.5-1.3.8-1.9,0-.1,0-.3-.1-.3l-11.1-5.7h.2Z" />
    </g>
    <path d="M134.5,452.4c.7,0,1.3-.6,1.3-1.3s-.6-1.3-1.3-1.3-1.3.6-1.3,1.3.6,1.3,1.3,1.3Z" />
    <path d="M130.8,456.4c.7,0,1.3-.6,1.3-1.3s-.6-1.3-1.3-1.3-1.3.6-1.3,1.3.6,1.3,1.3,1.3Z" />
  </svg>
);

export const Clock = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3466 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M142.6,3467.4c-2.5,0-5,.8-7.1,2.2s-3.8,3.4-4.7,5.8c-1,2.3-1.2,4.9-.7,7.4s1.7,4.8,3.5,6.6,4.1,3,6.6,3.5,5.1.2,7.4-.7,4.3-2.6,5.8-4.7c1.4-2.1,2.2-4.6,2.2-7.1s-1.4-6.7-3.8-9.1c-2.4-2.4-5.7-3.8-9.1-3.8h0ZM146.9,3484.5c-.2.2-.5.3-.8.3s-.6-.1-.8-.3l-3.5-3.5c-.2-.2-.3-.5-.3-.8v-7c0-.3.1-.6.3-.8s.5-.3.8-.3.6.1.8.3.3.5.3.8v6.5l3.2,3.2c.2.2.3.5.3.8s-.1.6-.3.8Z" />
  </svg>
);

export const Cross = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1978 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M144.7,1992l6.4-6.4c.6-.6.6-1.5,0-2.1s-1.5-.6-2.1,0l-6.4,6.4-6.4-6.4c-.6-.6-1.5-.6-2.1,0s-.6,1.5,0,2.1l6.4,6.4-6.4,6.4c-.6.6-.6,1.5,0,2.1.3.3.7.4,1.1.4s.8-.2,1.1-.4l6.4-6.4,6.4,6.4c.3.3.7.4,1.1.4s.8-.2,1.1-.4c.6-.6.6-1.5,0-2.1l-6.4-6.4h-.2Z" />
  </svg>
);

export const Culture = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2170 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M141.4,2174.2v.6h1.3c.3,0,.5.2.6.5l1.2,2.5c.1,0,.3,0,.4.2.1.1.3.2.5.3.4,0,.8,0,1-.3.3-.3.7-.3,1-.1.5.3.5.9.2,1.3-.5.5-1.2.8-2,.8h-.1l1.6,3.4c0,.2.1.3.2.4,1.8-.6,3.8-.1,5.3,1.3.3.3.4.8,0,1.2s-.4.3-.6.3-.4,0-.6-.2c-1-1-2.4-1.3-3.6-.9.5,1.9.4,3.8,0,5.6.2,0,.5.1.7.2h.8c4.2-1,7.2-4.8,7.2-9.1v-7.9c0-.4-.2-.7-.6-.9-1.2-.4-3.4-1-7-1s-5.8.6-7,1c-.4.1-.6.5-.6.9h.1ZM150.7,2178.1c.3-.3.9-.3,1.2,0,.2.2.5.3.8.3s.6-.1.8-.3c.3-.3.9-.3,1.2,0s.3.8,0,1.2c-.5.5-1.2.8-2,.8s-1.4-.3-2-.8c-.3-.3-.3-.9,0-1.2Z" />
          <path d="M145.7,2184.2l-3.4-7.2c-.2-.3-.5-.5-.9-.5-1.2,0-3.5.5-6.8,2-3.2,1.5-5,3-5.9,3.9-.3.3-.3.7-.2,1.1l3.3,7.1c1.8,3.9,6.1,6.1,10.4,5.2.3,0,.5-.2.7-.4,3.3-2.7,4.4-7.4,2.6-11.3h.2ZM138.9,2183.6c.5-1.4,2.1-2.2,3.6-1.7.4.2.7.6.5,1.1-.2.4-.6.7-1.1.5-.6-.2-1.2,0-1.4.7-.1.3-.4.6-.8.6s-.2,0-.3,0c-.4-.2-.7-.6-.5-1.1h0ZM135.7,2186.5h-.8c-.3.1-.5.4-.6.6-.1.3-.4.6-.8.6s-.2,0-.3,0c-.4-.2-.7-.6-.5-1.1.3-.7.8-1.3,1.4-1.6.7-.3,1.4-.4,2.1-.1.4.2.7.6.5,1.1-.2.4-.6.7-1.1.5h.1ZM138.5,2191.9c-.6,0-1.2,0-1.8-.3-.4-.2-.7-.6-.5-1.1.2-.4.6-.7,1.1-.5,1.9.7,3.9-.3,4.6-2.2.2-.4.6-.6,1.1-.5.4.2.7.6.5,1.1-.8,2.1-2.8,3.5-4.9,3.5h-.1Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Date = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3514 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M153.6,3525.2v-2.9c0-.8-.3-1.6-.9-2.2-.6-.6-1.4-.9-2.2-.9h-1.9v-1c0-.3-.1-.5-.3-.7s-.4-.3-.7-.3-.5.1-.7.3-.3.4-.3.7v1h-3v-1c0-.3-.1-.5-.3-.7s-.4-.3-.7-.3-.5.1-.7.3-.3.4-.3.7v1h-3v-1c0-.3-.1-.5-.3-.7s-.4-.3-.7-.3-.5.1-.7.3-.3.4-.3.7v1h-1.9c-.8,0-1.6.3-2.2.9-.6.6-.9,1.4-.9,2.2v2.9h22,0Z" />
      <path d="M131.6,3527.2v8.9c0,.8.3,1.6.9,2.2s1.4.9,2.2.9h15.8c.8,0,1.6-.3,2.2-.9s.9-1.4.9-2.2v-8.9h-22,0Z" />
    </g>
  </svg>
);

export const Delete = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 490 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M153.3,495.6h-21.6c-.3,0-.6.1-.8.4-.2.2-.4.5-.4.8s.1.6.4.8c.2.2.5.4.8.4h2.4v14.4c0,1,.4,1.9,1.1,2.5s1.6,1.1,2.5,1.1h9.6c1,0,1.9-.4,2.5-1.1s1.1-1.6,1.1-2.5v-14.4h2.4c.3,0,.6-.1.8-.4.2-.2.4-.5.4-.8s-.1-.6-.4-.8c-.2-.2-.5-.4-.8-.4ZM141.3,508.8c0,.3-.1.6-.4.8-.2.2-.5.4-.8.4s-.6-.1-.8-.4c-.2-.2-.4-.5-.4-.8v-6c0-.3.1-.6.4-.8.2-.2.5-.4.8-.4s.6.1.8.4c.2.2.4.5.4.8v6ZM146.1,508.8c0,.3-.1.6-.4.8-.2.2-.5.4-.8.4s-.6-.1-.8-.4c-.2-.2-.4-.5-.4-.8v-6c0-.3.1-.6.4-.8.2-.2.5-.4.8-.4s.6.1.8.4c.2.2.4.5.4.8v6Z" />
    <path d="M140.1,494.4h4.8c.3,0,.6-.1.8-.4.2-.2.4-.5.4-.8s-.1-.6-.4-.8c-.2-.2-.5-.4-.8-.4h-4.8c-.3,0-.6.1-.8.4-.2.2-.4.5-.4.8s.1.6.4.8c.2.2.5.4.8.4Z" />
  </svg>
);

export const Directions = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3370 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M156.1,3383.2l-12.6-12.6c-.5-.6-1.4-.6-2,0l-12.6,12.6c-.5.5-.5,1.4,0,2l12.6,12.6h0c.5.6,1.4.6,2,0l12.6-12.6c.5-.6.5-1.4,0-2ZM145.3,3387.7v-3.5h-5.6v4.2h-2.8v-5.6c0-.8.6-1.4,1.4-1.4h7v-3.5l4.9,4.9-4.9,4.9h0Z" />
      </g>
    </g>
  </svg>
);

export const Duration = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3898 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M145.4,3903.3h0v-1.9h1.5c.7,0,1.2-.5,1.2-1.2s-.6-1.2-1.2-1.2h-8.4c-.7,0-1.2.6-1.2,1.2s.6,1.2,1.2,1.2h1.5v1.8h0c-1.4.4-2.7.9-3.8,1.8l-1-1c-.5-.5-1.3-.5-1.8,0s-.5,1.3,0,1.8l.9.9c-1.7,1.9-2.7,4.5-2.7,7.2,0,6.1,4.9,11,11,11s11-4.9,11-11-3.5-9.4-8.2-10.7h0ZM142.6,3921.7c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8,7.7,3.5,7.7,7.8-3.5,7.8-7.7,7.8Z" />
      <path d="M143.7,3912.8l-.7-3.5c0-.5-.8-.5-.9,0l-.7,3.5c-.6.4-1,1.1-1,1.8,0,1.2,1,2.2,2.2,2.2s2.2-1,2.2-2.2-.4-1.5-1-1.8h-.1Z" />
    </g>
  </svg>
);

export const English = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 4138 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M156.5,4152c0,7.7-6.3,14-14,14h-.2c-.7,0-1.4,0-2-.2-.5,0-1.1-.2-1.6-.4-2.9-.8-5.5-2.6-7.4-5-1.8-2.4-2.8-5.4-2.8-8.5,0-7.7,6.3-14,14-14h0c1.9,0,3.8.4,5.5,1.1,1.7.8,3.3,1.9,4.6,3.2,2.5,2.6,3.8,6,3.8,9.6v.2Z" fill="#fff" />
          <path d="M139,4147.8v.6h-2l-5.7-4.8c.4-.5.7-.9,1.1-1.4l6.6,5.5h0Z" fill="#c8102e" />
          <path d="M153.8,4143.7l-5.7,4.7h-2.1v-.6l6.6-5.5h0c.4.4.7.8,1.1,1.3h0Z" fill="#c8102e" />
          <path d="M139,4155.5v.6l-6.6,5.5s-.1-.1-.2-.2c-.3-.4-.7-.8-1-1.2l5.7-4.8h2.1Z" fill="#c8102e" />
          <path d="M153.8,4160.3c-.4.5-.7.9-1.1,1.4l-6.6-5.5v-.6h2.1l5.7,4.7h0Z" fill="#c8102e" />
          <path d="M134.1,4148.5h-5.1c.3-1.1.7-2.2,1.3-3.2l3.9,3.2h0Z" fill="#012169" />
          <path d="M134,4155.5l-3.8,3.2c-.5-1-1-2.1-1.2-3.2h5Z" fill="#012169" />
          <path d="M139,4158.5v7.1h-.3c-1.8-.5-3.5-1.4-5-2.6l5.3-4.4h0Z" fill="#012169" />
          <path d="M139,4138.5v6.9l-5.2-4.3c1.5-1.2,3.3-2.1,5.2-2.6Z" fill="#012169" />
          <path d="M151.3,4141.1l-5.3,4.4v-7.1h0c1.9.5,3.7,1.4,5.2,2.7h.1Z" fill="#012169" />
          <path d="M156.1,4148.5h-5l3.8-3.1c.5,1,1,2,1.2,3.1Z" fill="#012169" />
          <path d="M151.4,4162.8c-1.6,1.3-3.4,2.2-5.3,2.7v-7.1l5.3,4.4Z" fill="#012169" />
          <path d="M156.1,4155.5c-.3,1.1-.7,2.1-1.2,3.1l-3.7-3.1h4.9Z" fill="#012169" />
          <path d="M156.5,4151.9v.3c0,.7,0,1.3-.2,2h-11.8v11.8c-.6,0-1.3.1-1.9.1h-.3c-.6,0-1.3,0-1.9-.1v-11.8h-11.8c0-.6-.1-1.3-.2-1.9v-.3c0-.7,0-1.3.2-2h11.8v-11.8c.6,0,1.2-.1,1.8-.1h.5c.6,0,1.2,0,1.8.1h.1v11.8h11.8c0,.6.1,1.3.2,1.9h-.1Z" fill="#c8102e" />
        </g>
      </g>
    </g>
  </svg>
);

export const Error = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1882 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M142.5,1882h0c7.7,0,14,6.3,14,14h0c0,7.7-6.3,14-14,14h0c-7.7,0-14-6.3-14-14h0c0-7.7,6.3-14,14-14Z" fill="#db1113" />
      <path d="M143.9,1896l4.3-4.3c.4-.4.4-1,0-1.4s-1-.4-1.4,0l-4.3,4.3-4.3-4.3c-.4-.4-1-.4-1.4,0s-.4,1,0,1.4l4.3,4.3-4.3,4.3c-.4.4-.4,1,0,1.4.2.2.5.3.7.3s.5,0,.7-.3l4.3-4.3,4.3,4.3c.2.2.5.3.7.3s.5,0,.7-.3c.4-.4.4-1,0-1.4l-4.3-4.3Z" fill="#fff" />
    </g>
  </svg>
);

export const ErrorStroke = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 778 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M142.5,778c-7.7,0-14,6.3-14,14s6.3,14,14,14,14-6.3,14-14-6.3-14-14-14ZM142.5,803.8c-6.5,0-11.8-5.3-11.8-11.8s5.3-11.8,11.8-11.8,11.8,5.3,11.8,11.8-5.3,11.8-11.8,11.8Z" />
          <path d="M147.3,795.2l-3.2-3.2,3.2-3.2c.4-.4.4-1.1,0-1.5s-1.1-.4-1.5,0l-3.2,3.2-3.2-3.2c-.4-.4-1.1-.4-1.5,0s-.4,1.1,0,1.5l3.2,3.2-3.2,3.2c-.4.4-.4,1.1,0,1.5s1.1.4,1.5,0l3.2-3.2,3.2,3.2c.4.4,1.1.4,1.5,0s.4-1.1,0-1.5Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Euro = ({ size = 24, textColor = '#fff', coinColor = '#f0a925', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 4330 28 28"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M142.5,4330c7.7,0,14,6.3,14,14s-6.3,14-14,14-14-6.3-14-14,6.3-14,14-14Z" fill={coinColor} />
          <path d="M142.5,4331.1c-7.1,0-12.9,5.8-12.9,12.9s5.8,12.9,12.9,12.9,12.9-5.8,12.9-12.9-5.8-12.9-12.9-12.9ZM147,4350.5c-.4.2-.8.3-1.2.4-1.6.4-3.1.5-4.7,0-1.9-.6-3.1-1.9-3.9-3.7-.1-.4-.2-.7-.4-1.1h-1.5c-.2,0-.4-.2-.4-.4v-1c0-.2.2-.5.4-.5h1.2v-.8h-1.2c-.2,0-.4-.2-.4-.4v-1c0-.2.2-.4.4-.4h1.6v-.2c.5-1.3,1.2-2.5,2.3-3.3.9-.7,1.9-1.1,3-1.2,1.6-.2,3.1,0,4.5.5,0,0,.2,0,.3.1.4.2.4.5.3.9-.2.4-.3.8-.5,1.2-.2.3-.4.4-.7.4-.5-.1-1-.3-1.5-.4-1-.2-2.1-.2-3.1.2-.9.3-1.4,1-1.8,1.8h3c.2,0,.4.2.4.5v1c0,.2-.2.5-.4.5h-3.5v.8h3.5c.2,0,.4.2.4.4v1c0,.2-.2.4-.4.4h-3.2c.4,1.1,1,1.9,2.2,2.3.9.3,1.9.3,2.8,0,.5-.1,1-.2,1.5-.4.4,0,.6,0,.8.4s.4.8.5,1.2c.1.4,0,.7-.3.8h0Z" fill={textColor} />
        </g>
      </g>
    </g>
  </svg>
);

export const Event = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1450 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M137.9,1451.8c-.5,0-.9.4-.9.9v.8h-1.4c-2.5,0-4.5,2-4.5,4.5v13.8c0,2.5,2,4.5,4.5,4.5h13.8c2.5,0,4.5-2,4.5-4.5v-13.8c0-2.5-2-4.5-4.5-4.5h-1.4v-.8c0-.5-.4-.9-.9-.9s-.9.4-.9.9v.8h-7.6v-.8c0-.5-.4-.9-.9-.9h.2ZM139.3,1461.3c.2,0,.3,0,.4-.3l.8-1.7c.4-.8,1.2-1.3,2-1.3s1.6.5,2,1.3l.8,1.7c0,.2.2.3.4.3l1.8.3c.9,0,1.6.7,1.8,1.5.3.8,0,1.7-.6,2.3l-1.3,1.3c-.1,0-.2.3-.1.4l.3,1.8c.1.9-.2,1.7-.9,2.2-.4.3-.9.4-1.3.4s-.7,0-1.1-.3l-1.6-.9h-.5l-1.6.9c-.8.4-1.7.3-2.4-.2s-1-1.4-.9-2.2l.3-1.8c0-.2,0-.3-.1-.4l-1.3-1.3c-.6-.6-.8-1.5-.6-2.3.3-.8,1-1.4,1.8-1.5l1.8-.3h.1Z" fill={color} />
      <path d="M137.3,1463.6s0,.3.1.5l1.3,1.3c.5.5.8,1.3.6,2l-.3,1.8c0,.3.1.4.2.5,0,0,.3.2.5,0l1.6-.9c.3-.2.7-.3,1.1-.3s.7,0,1.1.3l1.6.9c.3,0,.5,0,.5,0,0,0,.3-.2.2-.5l-.3-1.8c-.1-.7.1-1.5.6-2l1.3-1.3c.2-.2.2-.4.1-.5,0,0-.1-.3-.4-.3l-1.8-.3c-.7,0-1.4-.6-1.7-1.2l-.8-1.7c-.1-.3-.4-.3-.5-.3s-.3,0-.5.3l-.8,1.7c-.3.7-1,1.1-1.7,1.2l-1.8.3c-.3,0-.4.2-.4.3h.2Z" fill={color} />
    </g>
  </svg>
);

export const Eye_Closed = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 634 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M133.5,639h0c0,0-.2-.2-.3-.2h-.8c-.1,0-.2,0-.3.2,0,0-.2.2-.2.3v.4c0,.3.1.5.3.7l1.6,1.6c-1.9,1.3-3.5,3-4.8,4.9-.2.3-.3.7-.3,1s.1.7.3,1c3.3,4.9,8.5,7.7,13.7,7.7s3.4-.3,4.9-.8l2.5,2.5c.2.2.5.3.7.3s.5,0,.7-.3.3-.5.3-.7c0-.3-.1-.5-.3-.7l-17.9-17.9h-.1ZM142.5,653.9c-1,0-2-.2-2.8-.7-.9-.5-1.6-1.2-2.1-2s-.9-1.8-.9-2.8.1-2,.5-2.9l1.6,1.6c-.1.6-.1,1.3,0,1.9.2.6.5,1.2,1,1.6.5.4,1,.8,1.6,1s1.3.2,1.9,0l1.6,1.6c-.8.3-1.6.5-2.4.5v.2Z" />
          <path d="M156.2,647c-3.3-4.9-8.5-7.7-13.7-7.7s-3.4.3-4.9.8l2.5,2.5c1.1-.5,2.3-.6,3.5-.4,1.2.2,2.3.8,3.1,1.6s1.4,1.9,1.6,3.1c.2,1.2,0,2.4-.4,3.5l3.5,3.5c1.9-1.3,3.5-3,4.8-4.9.2-.3.3-.7.3-1s-.1-.7-.3-1h0Z" />
          <path d="M142.5,644.2h-.8l4.5,4.5c.1-.6.1-1.1,0-1.7-.1-.6-.4-1.1-.7-1.5-.4-.4-.8-.8-1.3-1s-1.1-.4-1.6-.4h0Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Eye_Opened = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 586 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M142.5,591.7c-5.4,0-10.2,2.9-13.8,7.7-.3.4-.3.9,0,1.3,3.6,4.8,8.4,7.7,13.8,7.7s10.2-2.9,13.8-7.7c.3-.4.3-.9,0-1.3-3.6-4.8-8.4-7.7-13.8-7.7ZM142.9,605.9c-3.6.2-6.5-2.7-6.3-6.3.2-2.9,2.6-5.3,5.5-5.5,3.6-.2,6.5,2.7,6.3,6.3-.2,2.9-2.6,5.3-5.5,5.5ZM142.7,603.2c-1.9,0-3.5-1.5-3.4-3.4,0-1.6,1.4-2.9,3-3,1.9,0,3.5,1.5,3.4,3.4-.1,1.6-1.4,2.9-3,3Z" />
      </g>
    </g>
  </svg>
);

export const Facebook = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3994 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <g>
            <path d="M142.5,4022c7.7,0,14-6.3,14-14s-6.3-14-14-14-14,6.3-14,14,6.3,14,14,14Z" fill="#3a559f" />
            <path d="M146.9,4006.3l-.3,2.4c0,.1,0,.2-.1.3,0,0-.2.1-.3.1h-2.5v7.2s0,.2-.1.2c0,0-.1.1-.2.1h-2.8v-7.4h-2.2v-3.2h2.2v-2.4c0-2.7,1.6-4.2,4-4.2h2.2v2.9h-1.5c-1.3,0-1.5.6-1.5,1.6v2h3s.1,0,.2.1v.4h0Z" fill="#fff" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Filters = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2026 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M151.9,2029.5h-18.7c-.5,0-.9,0-1.3.4s-.7.6-.9,1.1c-.2.4-.3.9-.2,1.4,0,.5.3.9.6,1.2l8.1,8.9v8.4c0,.2,0,.3.1.5,0,.1.2.2.4.3h.4c.2,0,.4,0,.5-.2l4.4-3.5c.1,0,.2-.2.2-.3v-5.3l8.1-8.9c.3-.3.5-.8.6-1.2,0-.5,0-.9-.2-1.4-.2-.4-.5-.8-.9-1.1s-.9-.4-1.3-.4h0Z" />
      </g>
    </g>
  </svg>
);

export const Fin = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1066 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M153.9,1069c-.2,0-.4,0-.5,0-.2,0-.4,0-.5.2-3.5,2.7-6.5,1.4-10,0s-7.5-3.3-12,0c-.1,0-.2.2-.3.3s-.1.3-.1.5v21.2c0,.3.1.5.3.7s.4.3.7.3.5,0,.7-.3c.2-.2.3-.5.3-.7v-5.6c3.4-2.3,6.3-1,9.6.4,2,.9,4.2,1.8,6.6,1.8s3.5-.5,5.4-1.9c.1,0,.2-.2.3-.4,0,0,.1-.3.1-.5v-15.2c0-.2,0-.4-.1-.5s-.2-.3-.4-.4h-.1ZM146,1085.4v-6.8c-2.4-.7-4.6-2-7-2.7v6.8c-2-.5-4.2-.6-6.5.6v-6.7c2.3-1.3,4.4-1.3,6.5-.7v-6.3c1.1.4,2.1.8,3.1,1.2,1.2.5,2.5,1.1,3.9,1.5v6.3c2.1.6,4.2.7,6.5-.7v6.6c-2.3,1.6-4.4,1.5-6.5.8h0Z" />
  </svg>
);

export const Football = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2218 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M142.6,2218.2c-7.7,0-14,6.3-14,14s6.3,14,14,14,14-6.3,14-14-6.3-14-14-14ZM143.4,2222.7l3.6-1.9c2,.8,3.7,2.1,5.1,3.7l-.9,3.9-2.7,1.4-5.1-3.7v-3.4h0ZM138.1,2220.8l3.6,1.9v3.4l-5,3.7-2.8-1.4-.9-4c1.3-1.6,3.1-2.9,5.1-3.7h0ZM132.5,2239.1c-1.1-1.7-1.9-3.6-2.1-5.7l3-3.2,2.7,1.3,2,5.8-1.7,2.1-3.9-.2h0ZM145.7,2244c-1,.3-2,.4-3.1.4s-2.6-.2-3.7-.6l-1.1-3.4,1.8-2.1h6.2l1.7,2-1.7,3.7h0ZM148.7,2239.3l-1.7-2,2.1-5.8,2.7-1.3,2.9,3.2c-.2,1.8-.8,3.5-1.7,5l-4.4.9h0Z" />
      </g>
    </g>
  </svg>
);

export const FreeAccess = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2698 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M148.9,2710.7h0v-3.2c0-4-3.3-7.3-7.3-7.3h-.3c-3.2.1-5.9,2.4-6.7,5.4-.3,1,.5,2,1.6,2s1.3-.5,1.5-1.2c.5-1.6,1.8-2.9,3.6-3h.4c2.3,0,4.1,1.8,4.1,4.1v3.2h-11.5c-1.1,0-1.9.9-1.9,1.9v10.3c0,1.1.9,1.9,1.9,1.9h14.8c1.1,0,1.9-.9,1.9-1.9v-10.3c0-1-.9-1.9-1.9-1.9h-.2ZM142.9,2720.1c0,.2-.1.4-.4.4h-2.2c-.2,0-.4-.2-.4-.4l.4-2c-.4-.4-.6-.9-.5-1.5.1-.7.7-1.2,1.4-1.3h.2c.9,0,1.6.7,1.6,1.6s-.2.9-.6,1.2l.4,2h.1Z" />
  </svg>
);

export const German = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 4090 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M130.3,4108.5c1.8,5,6.6,8.5,12.2,8.5s10.4-3.5,12.2-8.5l-12.2-1.1-12.2,1.1Z" fill="#ffda44" />
      <path d="M142.5,4091c-5.6,0-10.4,3.5-12.2,8.5l12.2,1.1,12.2-1.1c-1.8-4.9-6.6-8.5-12.2-8.5Z" fill="#3d3d3d" />
      <path d="M130.3,4099.5c-.5,1.5-.8,3-.8,4.5s.3,3.1.8,4.5h24.4c.5-1.5.8-3,.8-4.5s-.3-3.1-.8-4.5h-24.4Z" fill="#d80027" />
    </g>
  </svg>
);

export const Google = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3946 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <g>
            <path d="M134.7,3962.9l-1,3.6h-3.6c-1.1-1.9-1.7-4.2-1.7-6.6s.6-4.5,1.6-6.4h0l3.2.6,1.4,3.2c-.3.8-.4,1.8-.4,2.7s.2,2,.5,2.9Z" fill="#fbbb00" />
            <path d="M156.3,3957.4c.2.9.2,1.7.2,2.6s-.1,2-.3,2.9c-.7,3.2-2.5,6-4.9,8h0l-4-.2-.6-3.5c1.6-1,2.9-2.5,3.6-4.3h-7.5v-5.5h13.5Z" fill="#518ef8" />
            <path d="M151.3,3970.9h0c-2.4,1.9-5.4,3.1-8.8,3.1-5.3,0-10-3-12.3-7.4l4.5-3.7c1.2,3.2,4.2,5.4,7.8,5.4s3-.4,4.2-1.1l4.6,3.7Z" fill="#28b446" />
            <path d="M151.4,3949.2l-4.5,3.7c-1.3-.8-2.8-1.3-4.4-1.3-3.6,0-6.8,2.4-7.9,5.6l-4.6-3.7h0c2.3-4.5,7-7.6,12.4-7.6s6.5,1.2,8.9,3.2h.1Z" fill="#f14336" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const HalfDay = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="130.5 2844 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M154.2,2855.3l-3-3v-4.2c0-.5-.4-.9-.9-.9h-4.2l-3-3c-.4-.4-1-.4-1.3,0l-3,3h-4.2c-.5,0-.9.4-.9.9v4.2l-3,3c-.4.4-.4,1,0,1.3l3,3v4.2c0,.5.4.9.9.9h4.2l3,3c.4.4,1,.4,1.3,0l3-3h4.2c.5,0,.9-.4.9-.9v-4.2l3-3c.4-.4.4-1,0-1.3ZM143.2,2862.3c-.4,0-.7-.2-.7-.6h0v-11.2c0-.4.3-.7.7-.7s0,0,0,0c3.5.4,5.9,3.5,5.5,7-.3,2.9-2.6,5.2-5.5,5.5Z" />
      </g>
    </g>
  </svg>
);

export const Help = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 682 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M142.5,682c-7.7,0-14,6.3-14,14s6.3,14,14,14,14-6.3,14-14-6.3-14-14-14ZM142.5,708c-6.6,0-12-5.4-12-12s5.4-12,12-12,12,5.4,12,12-5.4,12-12,12Z" />
          <path d="M142.1,699.7c-.8,0-1.4.6-1.4,1.4s.6,1.4,1.4,1.4,1.4-.7,1.4-1.4-.6-1.4-1.4-1.4Z" />
          <path d="M142.3,689c-2.5,0-3.6,1.5-3.6,2.5s.6,1.1,1.1,1.1c1,0,.6-1.4,2.5-1.4s1.7.4,1.7,1.3-1,1.6-1.6,2.1c-.5.5-1.2,1.2-1.2,2.8s.3,1.2,1,1.2,1.1-.4,1.1-.8c0-1,0-1.5,1-2.3.5-.4,2.1-1.6,2.1-3.4s-1.6-3-3.9-3h-.2Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Infdoor = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3562 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M153.8,3575.3l-10.5-9.3c-.2-.2-.5-.3-.8-.3s-.6.1-.8.3l-10.5,9.3c-.1,0-.2.2-.3.4,0,.1-.1.3-.1.5v.4c0,.1.1.3.2.4.1.1.2.2.4.3.1,0,.3.1.4.1h.5c.1,0,.3-.1.4-.2l.4-.4v8.8c0,.3.1.6.3.8s.5.3.8.3h4.7c.3,0,.6-.1.8-.3s.3-.5.3-.8v-3.5c0-.3.1-.6.3-.8s.5-.3.8-.3h2.3c.3,0,.6.1.8.3s.3.5.3.8v3.5c0,.3.1.6.3.8s.5.3.8.3h4.7c.3,0,.6-.1.8-.3s.3-.5.3-.8v-8.8l.4.4c.1,0,.2.2.4.2h.5c.2,0,.3,0,.4-.1.1,0,.3-.2.4-.3.1-.1.2-.2.2-.4v-.4c0-.2,0-.3-.1-.4,0-.1-.2-.3-.3-.4h.5Z" />
  </svg>
);

export const InfoStroke = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 730 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M142.5,730c-7.7,0-14,6.3-14,14s6.3,14,14,14,14-6.3,14-14-6.3-14-14-14ZM142.5,755.5c-6.3,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5,11.5,5.1,11.5,11.5-5.1,11.5-11.5,11.5Z" />
          <path d="M142.5,735.9c-.9,0-1.7.8-1.7,1.7s.8,1.7,1.7,1.7,1.7-.8,1.7-1.7-.8-1.7-1.7-1.7Z" />
          <path d="M142.5,741.9c-.7,0-1.3.6-1.3,1.3v7.6c0,.7.6,1.3,1.3,1.3s1.3-.6,1.3-1.3v-7.6c0-.7-.6-1.3-1.3-1.3Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Instagram = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 4042 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <linearGradient id="Instagram_linear-gradient" x1="131.8" y1="252.7" x2="151.7" y2="232.8" gradientTransform="translate(0 3814)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fee411" />
        <stop offset="0" stopColor="#fedb16" />
        <stop offset="0" stopColor="#fec125" />
        <stop offset=".2" stopColor="#fe983d" />
        <stop offset=".4" stopColor="#fe5f5e" />
        <stop offset=".5" stopColor="#fe2181" />
        <stop offset="1" stopColor="#9000dc" />
      </linearGradient>
    </defs>
    <g>
      <g>
        <g>
          <path d="M142.5,4070c7.7,0,14-6.3,14-14s-6.3-14-14-14-14,6.3-14,14,6.3,14,14,14Z" fill="url(#Instagram_linear-gradient)" />
          <path d="M145.5,4048.2h-5.9c-2.7,0-4.8,2.2-4.8,4.8v5.9c0,2.7,2.2,4.8,4.8,4.8h5.9c2.7,0,4.8-2.1,4.8-4.8v-5.9c0-2.7-2.2-4.8-4.8-4.8ZM148.5,4059c0,1.7-1.4,3.1-3.1,3.1h-5.9c-1.7,0-3.1-1.4-3.1-3.1v-5.9c0-1.7,1.4-3.1,3.1-3.1h5.9c1.7,0,3.1,1.4,3.1,3.1v5.9Z" fill="#fff" />
          <path d="M142.5,4052c-2.2,0-4,1.8-4,4s1.8,4,4,4,4-1.8,4-4-1.8-4-4-4ZM142.5,4058.4c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4,2.4,1.1,2.4,2.4-1.1,2.4-2.4,2.4Z" fill="#fff" />
          <path d="M146.8,4052.5c.4,0,.6-.4.6-.8s-.4-.6-.8-.6-.6.4-.6.8.4.6.8.6Z" fill="#fff" />
        </g>
      </g>
    </g>
  </svg>
);

export const GoogleIcon = ({ size = 20, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

export const Locate = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 922 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M142.5,930.8c-2.9,0-5.2,2.4-5.2,5.2s2.4,5.2,5.2,5.2,5.2-2.4,5.2-5.2-2.4-5.2-5.2-5.2ZM142.5,939.5c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5,3.5,1.6,3.5,3.5-1.6,3.5-3.5,3.5Z" />
          <path d="M155.6,935.1h-2.7c-.4-5.1-4.5-9.2-9.6-9.6v-2.7c0-.5-.4-.9-.9-.9s-.9.4-.9.9v2.7c-5.1.4-9.2,4.5-9.6,9.6h-2.7c-.5,0-.9.4-.9.9s.4.9.9.9h2.7c.4,5.1,4.5,9.2,9.6,9.6v2.7c0,.5.4.9.9.9s.9-.4.9-.9v-2.7c5.1-.4,9.2-4.5,9.6-9.6h2.7c.5,0,.9-.4.9-.9s-.4-.9-.9-.9ZM142.5,944.8c-4.8,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8,8.8,3.9,8.8,8.8-3.9,8.8-8.8,8.8Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Location = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 970 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M142.5,970c-2.8,0-5.5,1.1-7.4,3.1-2,2-3.1,4.6-3.1,7.4,0,7.5,9.8,17,10.2,17.4,0,0,.2,0,.3,0s.2,0,.3,0c.4-.4,10.2-9.8,10.2-17.4s-1.1-5.5-3.1-7.4c-2-2-4.6-3.1-7.4-3.1ZM142.5,985.3c-1,0-1.9-.3-2.7-.8s-1.4-1.3-1.8-2.2c-.4-.9-.5-1.8-.3-2.8.2-.9.6-1.8,1.3-2.5s1.5-1.1,2.5-1.3c.9-.2,1.9,0,2.8.3.9.4,1.6,1,2.2,1.8.5.8.8,1.7.8,2.7s-.5,2.5-1.4,3.4-2.1,1.4-3.4,1.4h0Z" />
      </g>
    </g>
  </svg>
);

export const LogOut = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3322 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M137.9,3328.1c.6,0,1.1-.5,1.1-1v-1.1c0-.6-.5-1.1-1.1-1.1h-3.8c-1.5,0-2.7,1.2-2.7,2.6v16.8c0,1.5,1.2,2.6,2.7,2.6h3.8c.6,0,1.1-.5,1.1-1.1v-1.1c0-.6-.5-1-1.1-1h-3.2v-15.7h3.2Z" />
      <path d="M147.1,3331.8c0-.4.3-.8.7-1s.9,0,1.2.2l4.3,4.2c.4.4.4,1.1,0,1.5l-4.3,4.2c-.3.3-.8.4-1.2.2s-.7-.5-.7-1v-2.6h-8.6c-.6,0-1.1-.5-1.1-1.1v-1c0-.6.5-1.1,1.1-1.1h8.6v-2.6h0Z" />
    </g>
  </svg>
);

export const Manual = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3226 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M143.1,3234.1l-9.4,9.4c-.3.3-.6.8-.6,1.3l-.4,3.3v.7c0,.2.2.4.3.6.2.2.3.3.6.4.2,0,.4.1.7.1h.2l3.3-.4c.5,0,.9-.3,1.3-.6l9.4-9.4-5.4-5.4h0Z" />
      <path d="M151.8,3233.4l-2.4-2.4c-.2-.2-.4-.4-.7-.5s-.5-.2-.8-.2-.6,0-.8.2c-.3.1-.5.3-.7.5l-2.2,2.2,5.4,5.4,2.2-2.2c.2-.2.4-.4.5-.7s.2-.5.2-.8,0-.6-.2-.8c-.1-.3-.3-.5-.5-.7Z" />
    </g>
  </svg>
);

export const ManualBlack = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3274 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M143.1,3282.1l-9.4,9.4c-.3.3-.6.8-.6,1.3l-.4,3.3v.7c0,.2.2.4.3.6.2.2.3.3.6.4.2,0,.4.1.7.1h.2l3.3-.4c.5,0,.9-.3,1.3-.6l9.4-9.4-5.4-5.4h0Z" />
      <path d="M151.8,3281.4l-2.4-2.4c-.2-.2-.4-.4-.7-.5s-.5-.2-.8-.2-.6,0-.8.2c-.3.1-.5.3-.7.5l-2.2,2.2,5.4,5.4,2.2-2.2c.2-.2.4-.4.5-.7s.2-.5.2-.8,0-.6-.2-.8c-.1-.3-.3-.5-.5-.7Z" />
    </g>
  </svg>
);

export const Map = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2074 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M146,2096.1l-6.9,1.4v-17.2l6.9-1.4v17.2ZM137.4,2080.2l-5.8-1.5h-.4c-.1,0-.2,0-.4.2-.1,0-.2.2-.2.3v15.9c0,.2,0,.4.2.5.1.2.3.3.5.3l6.2,1.5v-17.3h-.1ZM153.9,2080.4l-6.2-1.5v17.3l5.8,1.5h.2c.2,0,.4,0,.6-.2.2-.2.3-.4.3-.6v-15.5c0-.2,0-.4-.2-.6-.1-.1-.3-.3-.5-.3h0Z" />
  </svg>
);

export const Multiday = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2650 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M130.2,2670.9h18.4c.2,0,.3,0,.4-.2.2-.1,4.2-3.6,4.4-11.1h-19.7c-.2,6.8-4,10-4,10-.2.2-.3.5-.2.8s.4.5.7.5h0Z" />
      <path d="M152.8,2655.4h-3.5v-.7c0-.4-.3-.7-.7-.7s-.7.3-.7.7v.7h-3.6v-.7c0-.4-.3-.7-.7-.7s-.7.3-.7.7v.7h-3.5v-.7c0-.4-.3-.7-.7-.7s-.7.3-.7.7v.7h-3.5c-.4,0-.7.3-.7.7v2.1h19.7v-2.1c0-.4-.3-.7-.7-.7h0Z" />
      <path d="M149.9,2671.8c-.4.3-.9.5-1.4.5h-14.8v2.1c0,.4.3.7.7.7h18.3c.4,0,.7-.3.7-.7v-7.9c-1.4,3.3-3.2,5-3.6,5.3h.1Z" />
    </g>
  </svg>
);

export const Museum = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2266 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M131.2,2289h5.1l-.6-8.1h-3.9l-.6,8.1Z" />
          <path d="M140,2289h5.1l-.6-8.1h-3.9l-.6,8.1Z" />
          <path d="M148.8,2289h5.1l-.6-8.1h-3.9l-.6,8.1Z" />
          <path d="M155.7,2292.5h0v-1.1c0-.4-.4-.8-.8-.8h-24.6c-.5,0-.8.4-.8.8v1.1h0c-.5,0-.8.4-.8.8s.4.8.8.8h26.4c.5,0,.8-.4.8-.8s-.4-.8-.8-.8h-.2Z" />
          <path d="M154.8,2278.4v-1.1h-24.5v1.1c0,.4.4.8.8.8h22.8c.5,0,.8-.4.8-.8h0Z" />
          <path d="M129.4,2275.7h26.4c.4,0,.7-.2.8-.6,0-.3,0-.7-.4-.9l-13.2-7.9c-.3-.2-.6-.2-.8,0l-13.2,7.9c-.3.2-.5.6-.4.9,0,.4.4.6.8.6h0Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Nature = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2314 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M145.2,2328.2c-.5.5-1.1,1.2-1.6,2.1-.5-1.8-1.1-3.1-1.8-4.1,2.9-9.7-11.3-10.1-11.3-10.1,0,0,.4,12.2,7.8,11.9,0-.8-.1-1.6-.3-2.4-.1-.5-.3-1-.4-1.4-.5-1.5-1-2.5-1-2.5.5.7,1,1.4,1.4,2.1,1.5,2.2,2.3,4,2.6,4.9.9,1.9,1.7,5.2,1.7,10.4s.5,1.1,1.1,1.1,1.1-.5,1.1-1.1c0-1.7,0-3.2-.2-4.6.3-1.7.9-2.8,1.4-3.7.4-.7,1-1.8,1.9-3,.8-1,1.7-2.1,2.8-2.9,0,0-2.2,2.5-2.4,4.9,6.2.3,6.4-9.4,6.4-9.4,0,0-11.3.4-9.3,7.7h.1Z" />
  </svg>
);

export const OneTime = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2602 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M139.6,2612.8l.5-.3v7.8c0,.4.3.8.8.8h3.3c.4,0,.8-.3.8-.8v-10.7c0-.3-.1-.5-.4-.7-.2-.1-.5-.1-.7,0l-4.9,2.5c-.4.2-.5.7-.3,1,.2.4.6.5,1,.4h-.1Z" />
      <path d="M155.4,2616.6c-.2-.4-.7-.5-1-.3l-.6.3v-.9l1.4-1.4c.3-.3.3-.8,0-1.1s-.8-.3-1.1,0l-.5.5c0-.3-.1-.6-.2-.9l1-1.7c.2-.4,0-.8-.3-1.1-.4-.2-.8,0-1,.3l-.3.6c-.1-.3-.3-.6-.4-.9l.5-1.9c.1-.4-.1-.8-.5-.9-.4-.1-.8.1-.9.6l-.2.6c-.2-.2-.4-.5-.6-.7v-2.1c0-1-1.5-1-1.5,0v.7c-.4-.3-.8-.5-1.1-.7-.4-.2-.8,0-1,.3-.2.4,0,.8.3,1.1.3.2.7.4,1.1.7l-.5.2c-.4.1-.6.6-.5,1s.6.6,1,.5l1.3-.4c.2.2.4.4.5.6h-.5c-.4,0-.7.4-.7.8s.4.8.8.7h1.3c.1.2.2.4.4.7h-.5c-.4-.2-.8,0-.9.5,0,.4.2.8.6.9l1.3.3c0,.3.1.5.1.8l-.5-.2c-.4-.2-.8,0-1,.3-.2.4,0,.8.3,1l1.2.6v.8l-.4-.3c-.3-.3-.8-.2-1.1,0-.3.3-.2.8,0,1.1l1,.9c0,.3-.2.5-.3.8l-.3-.4c-.2-.4-.7-.4-1.1-.2-.4.2-.4.7-.2,1.1l.7,1.1c-.1.2-.3.5-.5.7l-.2-.5c-.1-.4-.6-.6-1-.5s-.6.6-.5,1l.4,1.3c-.2.2-.4.4-.6.5v-.5c0-.4-.4-.7-.8-.7s-.7.4-.7.8v1.4c-.2.1-.4.2-.7.4v-.5c.2-.4,0-.8-.5-.9-.4,0-.8.2-.9.6l-.3,1.3c-1.3.3-2.8.3-4.2,0l-.3-1.3c0-.4-.5-.7-.9-.6-.4,0-.7.5-.6.9v.5c-.2-.1-.4-.2-.7-.4v-1.4c.1-.4-.2-.8-.6-.8s-.8.3-.8.7v.5c-.2-.2-.5-.4-.7-.5l.4-1.3c.1-.4,0-.8-.5-1-.4-.1-.8,0-1,.5l-.2.5c-.2-.2-.3-.5-.5-.7l.7-1.1c.2-.4.1-.8-.2-1.1-.4-.2-.8-.1-1.1.2l-.3.4c-.1-.3-.2-.5-.3-.8l1-.9c.3-.3.3-.8,0-1.1s-.8-.3-1.1,0l-.4.3v-.8l1.2-.6c.4-.2.5-.6.3-1s-.6-.5-1-.3l-.5.2c0-.3,0-.6.1-.8l1.3-.3c.4,0,.7-.5.6-.9,0-.4-.5-.7-.9-.6h-.5c.1-.2.2-.4.4-.7h1.3c.4.1.8-.2.8-.6s-.3-.8-.7-.8h-.5c.2-.3.4-.5.5-.7l1.3.4c.4.1.8,0,1-.5.1-.4,0-.9-.5-1l-.5-.2c.4-.3.8-.6,1.1-.7.4-.2.5-.7.3-1.1-.2-.4-.7-.5-1-.3s-.7.4-1.1.7v-.7c0-1-1.5-1-1.5,0v2.1c-.2.2-.4.4-.6.7l-.2-.6c-.1-.4-.5-.7-.9-.6-.4.1-.6.5-.5.9l.5,1.9c-.1.3-.3.6-.4.9l-.3-.6c-.2-.4-.7-.5-1-.3-.4.2-.5.7-.3,1.1l1,1.7c0,.3-.1.6-.2.9l-.5-.5c-.3-.3-.8-.3-1.1,0s-.3.8,0,1.1l1.4,1.4v.9l-.6-.3c-.4-.2-.8,0-1,.3-.2.4,0,.8.3,1.1l1.7,1c0,.3.2.6.3.9l-.6-.2c-.4-.1-.8.1-.9.5-.1.4.1.8.5.9l1.9.5c.2.3.3.5.5.8h-.7c-1,0-1,1.5,0,1.5h2c.2.2.5.4.7.6l-.6.2c-.4.1-.6.5-.5.9s.5.6.9.5l1.9-.5c.3.1.6.3.8.4l-.6.3c-.4.2-.5.7-.3,1.1.2.3.6.5,1,.3l1.7-1c1.7.4,3.6.4,5.3,0l1.7,1c.4.2.9,0,1-.3.2-.4,0-.8-.3-1.1l-.6-.3c.3-.1.6-.3.8-.4l1.9.5c.4.1.8-.1.9-.5.1-.4-.1-.8-.5-.9l-.6-.2c.2-.2.5-.4.7-.6h2c1,0,1-1.5,0-1.5h-.7c.2-.3.4-.5.5-.8l1.9-.5c.4-.1.6-.5.5-.9s-.5-.6-.9-.5l-.6.2c.1-.3.2-.6.3-.9l1.7-1c.4-.2.5-.7.3-1.1h1.4Z" />
    </g>
  </svg>
);

export const Outdoor = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3610 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M153.5,3623.8c0,3.3-2.7,5.9-5.9,5.9h-3.6l.6,7.8h-3.9l.6-7.8h-3.6c-3.3,0-5.9-2.6-5.9-5.9s1.8-5,4.3-5.7v-.6c0-3.6,3-6.6,6.6-6.6s6.6,3,6.6,6.6,0,.4,0,.6c2.5.7,4.3,3,4.3,5.7h-.1Z" />
  </svg>
);

export const PDF = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3130 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M153.6,3138.1h-22.1c-1.4,0-2.5,1.1-2.5,2.5v9.8c0,1.4,1.1,2.5,2.5,2.5h22.1c1.4,0,2.5-1.1,2.5-2.5v-9.8c0-1.4-1.1-2.5-2.5-2.5ZM135.5,3146.8h-.9v1.9c0,.5-.4.8-.8.8s-.8-.4-.8-.8v-6.2c0-.2,0-.4.2-.6.2-.2.4-.2.6-.2h1.7c1.4,0,2.6,1.1,2.6,2.6s-1.2,2.6-2.6,2.6h0ZM142.6,3149.3h-1.8c-.2,0-.4,0-.6-.2-.2-.2-.2-.4-.2-.6v-6.1c0-.2,0-.4.2-.6.2-.2.4-.2.6-.2h1.7c2,0,3.3,1.5,3.3,3.8s-1.3,3.8-3.2,3.8h0ZM151,3144.6c.5,0,.8.4.8.8s-.4.8-.8.8h-1.5v2.3c0,.4-.4.8-.8.8s-.8-.4-.8-.8v-6.2c0-.5.4-.8.8-.8h2.5c.5,0,.8.4.8.8s-.4.8-.8.8h-1.7v1.4h1.5Z" fill="#fff" />
          <path d="M142.5,3143.3h-.9v4.4h.9c1.1,0,1.6-1.1,1.6-2.2s-.1-2.2-1.6-2.2Z" fill="#fff" />
          <path d="M135.5,3143.3h-.9v1.8h.9c.5,0,1-.4,1-.9s-.4-.9-1-.9Z" fill="#fff" />
          <path d="M152.7,3136.5c-.2-.5-.5-1-.9-1.4l-3.4-3.6c-.8-.8-1.9-1.3-3-1.3h-10.9c-1.4,0-2.5,1.1-2.5,2.5v3.8h20.7Z" fill="#fff" />
          <path d="M132.1,3154.5v1.2c0,1.4,1.1,2.5,2.5,2.5h16c1.4,0,2.5-1.1,2.5-2.5v-1.2h-21Z" fill="#fff" />
        </g>
      </g>
    </g>
  </svg>
);

export const Pass = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1354 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M142.6,1355.2c-3.5,0-6.4,2.9-6.4,6.4v4h-.8c-1.5,0-2.8,1.3-2.8,2.8v9.6c0,1.6,1.3,2.8,2.8,2.8h14.4c1.5,0,2.8-1.2,2.8-2.8v-9.6c0-1.5-1.3-2.8-2.8-2.8h-.8v-4c0-3.5-2.9-6.4-6.4-6.4ZM138.6,1361.6c0-2.2,1.8-4,4-4s4,1.8,4,4v4h-8v-4ZM138.2,1374.4c-.7,0-1.2-.5-1.2-1.2s.5-1.2,1.2-1.2,1.2.5,1.2,1.2-.5,1.2-1.2,1.2ZM142.6,1374.4c-.7,0-1.2-.5-1.2-1.2s.5-1.2,1.2-1.2,1.2.5,1.2,1.2-.5,1.2-1.2,1.2ZM147,1374.4c-.7,0-1.2-.5-1.2-1.2s.5-1.2,1.2-1.2,1.2.5,1.2,1.2-.5,1.2-1.2,1.2Z" fill="#fff" />
  </svg>
);

export const Pass_Key = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1402 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M152.2,1406.3c-1.3-1.3-3-2.1-4.8-2.3-1.8-.2-3.7.3-5.2,1.3s-2.6,2.6-3.2,4.3c-.5,1.8-.4,3.6.3,5.3-3,2.6-5.8,5.4-8.4,8.4-.3.3-.5.8-.4,1.3,0,.7,0,1.5.1,2.2,0,.3.1.5.3.7s.4.3.7.3c.7,0,1.4,0,2.2,0,.5,0,1,0,1.3-.4.2,0,.3-.3.5-.4.1,0,.2-.3.2-.4,0-.4.1-.8.2-1.2,0-.6.6-1,1.3-.9,1.2.2,2.2-.7,2-1.9h0c-.1-.7.3-1.2.9-1.3.4,0,.8,0,1.2,0,.2,0,.3,0,.4-.2.6-.6,1.1-1.2,1.7-1.8,1.7.7,3.6.8,5.3.3,1.8-.5,3.3-1.6,4.3-3.1s1.5-3.4,1.3-5.2c-.2-1.8-1-3.5-2.3-4.8v-.2ZM150.2,1411.4c-.3.3-.7.5-1.1.6-.4,0-.9,0-1.3,0-.4-.2-.7-.5-1-.8-.2-.4-.4-.8-.4-1.2s.1-.8.4-1.2c.2-.4.6-.6,1-.8.4-.2.8-.2,1.3,0,.4,0,.8.3,1.1.6.2.2.4.4.5.7.1.3.2.6.2.8s0,.6-.2.8c-.1.3-.3.5-.5.7Z" fill="#fff" />
  </svg>
);

export const Playground = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2362 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M155.1,2365.7c0-.4-.3-.6-.7-.6h-7.7v-.7c0-.4-.3-.7-.7-.7s-.7.3-.7.7v.7h-5.6v-.7c0-.4-.3-.7-.7-.7s-.7.3-.7.7v.7h-7.7c-.4,0-.7.3-.7.6l-1.4,22.4c0,.4.3.7.7.8h1.4c.4,0,.7-.3.7-.7l1.4-21.7h5.6v14h-.7c-.4,0-.7.3-.7.7v1.4c0,.4.3.7.7.7h.7v.7c0,.4.3.7.7.7s.7-.3.7-.7v-.7h5.6v.7c0,.4.3.7.7.7s.7-.3.7-.7v-.7h.7c.4,0,.7-.3.7-.7v-1.4c0-.4-.3-.7-.7-.7s0,0,0,0h-.7v-14h5.6l1.4,21.7c0,.4.3.7.7.7h1.4c.4,0,.7-.3.7-.7s0,0,0,0l-1.4-22.4h0ZM145.4,2380.4h-5.6v-14h5.6v14Z" />
      </g>
    </g>
  </svg>
);

export const Plus = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1546 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M150,1558.4h-5.8v-5.8c0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6,1.6v5.8h-5.8c-.9,0-1.6.7-1.6,1.6s.7,1.6,1.6,1.6h5.8v5.8c0,.9.7,1.6,1.6,1.6s1.6-.7,1.6-1.6v-5.8h5.8c.9,0,1.6-.7,1.6-1.6s-.7-1.6-1.6-1.6Z" fill="#000" />
  </svg>
);

export const Pool = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2410 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M153.7,2430.7c-.2-.4-.5-.6-1-.4l-1.9.7c-2,.7-4.3.4-6.2-.4h.2c1.3-1.4,1.3-3.5,0-4.8l-5.6-5.6c-1-1.1-2.8-1.1-3.8,0l-3.3,3.3c-.2.2-.4.5-.4.9s.1.7.4.9c.4.4,1.1.5,1.6.1l3.7-2.4,2.1,2.1-1.9,1.9c-1.2,0-2.5,0-3.7.5l-1.9.7c-.4.1-.6.5-.4,1,.1.4.5.6,1,.4l1.9-.7c2.7-.9,5.7-.3,7.8,1.6,1.7,1.6,4,2.4,6.3,2.4s2-.2,3-.4l2-.7c.3-.1.5-.6.4-1h-.3Z" />
      <path d="M147.8,2424.9c2.1,0,3.8-1.6,3.8-3.8s-1.7-3.8-3.8-3.8-3.8,1.7-3.8,3.8,1.6,3.8,3.8,3.8Z" />
    </g>
  </svg>
);

export const Reccuring = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2554 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M152.5,2557.7c0-.5-.3-.9-.7-1.1-.4-.2-.9,0-1.3.2l-1.2,1.2c-.2.2-.5.2-.7,0-1.7-1-3.8-1.6-6-1.6-6.4,0-11.7,5.2-11.7,11.7s.5,1.2,1.2,1.2,1.2-.5,1.2-1.2c0-5.2,4.2-9.3,9.3-9.3s2.8.3,4,.9c.3.2.4.6.1.9l-.9.9c-.3.3-.4.8-.3,1.3.2.4.6.7,1.1.7h4.7c.6,0,1.2-.5,1.2-1.2v-4.7h0ZM138.5,2576.6c-.3-.2-.4-.6-.1-.9l.9-.9c.3-.3.4-.8.3-1.3-.2-.4-.6-.7-1.1-.7h-4.7c-.6,0-1.2.5-1.2,1.2v4.7c0,.5.3.9.7,1.1.4.2.9,0,1.3-.2l1.2-1.2c.2-.2.5-.2.7,0,1.7,1,3.8,1.6,6,1.6,6.4,0,11.7-5.2,11.7-11.7s-.5-1.2-1.2-1.2-1.2.5-1.2,1.2c0,5.2-4.2,9.3-9.3,9.3s-2.8-.3-4-.9h0Z" fillRule="evenodd" />
  </svg>
);

export const Research = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2458 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M151.6,2481.7c.9-1.5,1.4-3.1,1.4-4.9,0-4-2.6-7.6-6.4-8.8-.5-.8-1.4-1.4-2.3-1.6l.5-1.1c.1-.3,0-.6-.3-.8l.5-1c.3.1.6,0,.8-.3l1.2-2.5c.1-.3,0-.6-.3-.8l-3.5-1.8c-.3-.1-.6,0-.8.3l-1.2,2.5c-.1.3,0,.6.3.8l-.5,1c-.3-.1-.6,0-.8.3l-4.7,9.5c-.1.3,0,.6.3.8l3.5,1.8h.3c.2,0,.4-.1.5-.3l1.2-2.4c.6.6,1.5.9,2.4.9s1.5-.2,2-.7c1.6.8,2.6,2.4,2.6,4.2,0,2.6-2.1,4.7-4.7,4.7h-4.7v-1.2h1.8c.3,0,.6-.3.6-.6s-.3-.6-.6-.6h-8.2c-.3,0-.6.3-.6.6s.3.6.6.6h1.8v1.2c-1.3,0-2.3,1.1-2.3,2.3v1.8c0,.3.3.6.6.6h19.8c.3,0,.6-.3.6-.6v-1.8c0-1-.6-1.8-1.4-2.1h0ZM143.7,2471c-.6,0-1.2-.5-1.2-1.2s.5-1.2,1.2-1.2,1.2.5,1.2,1.2-.5,1.2-1.2,1.2Z" />
      </g>
    </g>
  </svg>
);

export const Resend = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1114 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M150.4,1116.4l1.4-.3c.5,0,.7-.5.6-1-.1-.4-.6-.7-1-.6l-3.4.8c-.5,0-.7.6-.6,1l.8,3.4c0,.4.4.7.8.7s.1,0,.2,0c.5,0,.7-.6.6-1l-.3-1.5c3.8,2.6,5.8,7,5.3,11.5-.4,3.3-2,6.2-4.5,8.3-2.2,1.8-4.9,2.7-7.7,2.7s-.9,0-1.4,0-.9.3-.9.7.3.9.7.9h1.6c3.2,0,6.2-1.1,8.7-3.1,2.9-2.3,4.8-5.7,5.2-9.4.6-5.2-1.8-10.2-6.1-13.1h0Z" />
          <path d="M136.8,1136.2c-.1-.5-.6-.7-1-.6-.5,0-.7.5-.6,1l.4,1.6c-3.7-2.6-5.7-6.9-5.2-11.5.4-3.3,2-6.2,4.5-8.3,2.6-2.1,5.8-3,9.1-2.6.5,0,.9-.3.9-.7s-.3-.9-.7-.9c-3.7-.4-7.4.6-10.3,3-2.9,2.3-4.8,5.7-5.2,9.4-.6,5.1,1.7,10.1,5.8,13l-1.4.3c-.5,0-.7.6-.6,1,0,.4.4.7.8.7s.1,0,.2,0l3.4-.8c.5,0,.7-.6.6-1l-.8-3.4v-.2Z" />
          <path d="M149.9,1122.3h-14.6c-.5,0-.8.4-.8.8v9.7c0,.5.4.8.8.8h14.6c.5,0,.8-.4.8-.8v-9.7c0-.5-.4-.8-.8-.8ZM147.7,1124l-5.1,4.7-5.1-4.7h10.3,0ZM136.1,1132v-7l5.9,5.4c.2,0,.4.2.6.2s.4,0,.6-.2l5.9-5.4v7h-13Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const SBB = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3082 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M136.1,3102.9h3.8l-5-5.2h6.3v5.2h3v-5.2h6.3l-5.1,5.2h3.8l6.4-6.7-6.4-6.7h-3.8l5.1,5.2h-6.3v-5.2h-3v5.2h-6.3l5-5.2h-3.8l-6.4,6.7,6.4,6.7Z" fill="#fff" />
  </svg>
);

export const Search = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1930 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M147.3,1950.3l5.3,5.4c.4.4,1.2.4,1.6,0,.4-.5.4-1.2,0-1.6l-5.3-5.4c1.4-1.8,2.3-4,2.3-6.4,0-5.7-4.6-10.3-10.3-10.3s-10.3,4.6-10.3,10.3,4.6,10.3,10.3,10.3,4.7-.8,6.4-2.2h0ZM140.8,1934.3c4.4,0,8,3.6,8,8s-3.6,8-8,8-8-3.6-8-8,3.6-8,8-8Z" fillRule="evenodd" />
  </svg>
);

export const Share = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3418 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M150.4,3426.6h-2.9c-.6,0-1,.5-1,1s.5,1,1,1h2.9c.6,0,1,.5,1,1v13.4c0,.6-.5,1-1,1h-15.7c-.6,0-1-.5-1-1v-13.4c0-.6.5-1,1-1h2.9c.6,0,1-.5,1-1s-.5-1-1-1h-2.9c-1.7,0-3.1,1.4-3.1,3.1v13.4c0,1.7,1.4,3.1,3.1,3.1h15.7c1.7,0,3.1-1.4,3.1-3.1v-13.4c0-1.7-1.4-3.1-3.1-3.1ZM138.7,3424.5l2.9-2.8v13.5c0,.6.5,1,1,1s1-.5,1-1v-13.5l2.9,2.8c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1.1,0-1.4l-4.7-4.6c-.4-.4-1.1-.4-1.5,0l-4.7,4.6c-.4.4-.4,1,0,1.4s1.1.4,1.5,0h.2Z" />
      </g>
    </g>
  </svg>
);

export const Sorting = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2122 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M142.5,2132.7c0,.1-.2.2-.3.2h-.8c-.1,0-.2-.1-.3-.2l-2.8-2.7v12.2c0,.3-.1.5-.3.7s-.4.3-.7.3-.5,0-.7-.3c-.2-.2-.3-.4-.3-.7v-12.2l-2.8,2.7s-.2.2-.3.2h-.8c-.1,0-.2-.1-.3-.2,0,0-.2-.2-.2-.3v-.8c0-.1.1-.2.2-.3l4.5-4.4h0l4.5,4.4s.2.2.2.3v.8c0,.1-.1.2-.2.3h1.4ZM153,2139.6s-.2-.2-.3-.2h-.8c-.1,0-.2.1-.3.2l-2.8,2.7v-12.2c0-.3-.1-.5-.3-.7s-.4-.3-.7-.3-.5.1-.7.3-.3.4-.3.7v12.2l-2.8-2.7s-.2-.2-.3-.2h-.8c-.1,0-.2.1-.3.2,0,0-.2.2-.2.3v.8c0,.1.1.2.2.3l4.5,4.4h.6l4.5-4.4s.2-.2.2-.3v-.8c0-.1-.1-.2-.2-.3h.8Z" />
  </svg>
);

export const Start = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1018 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M150.8,1029.6l-13.8-8c-1.8-1.1-4.1.3-4.1,2.4v15.9c0,2.1,2.3,3.5,4.1,2.4l13.8-7.9c1.8-1.1,1.8-3.7,0-4.8Z" />
  </svg>
);

export const Time = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2938 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M151,2946.5l1.7-1.7-1.7-1.7-1.8,1.8c-1.6-1.2-3.6-1.9-5.5-2.1v-2.4h2.3v-2.3h-7v2.3h2.3v2.4c-2,.2-3.9.9-5.5,2.1l-1.8-1.8-1.6,1.7,1.7,1.7c-1.6,1.7-2.6,3.7-3,6-.4,2.2-.1,4.6.8,6.6.9,2.1,2.4,3.9,4.3,5.1,1.9,1.2,4.1,1.9,6.4,1.9s4.5-.7,6.4-1.9,3.4-3,4.3-5.1c.9-2.1,1.2-4.4.8-6.6-.4-2.2-1.4-4.3-3-6h0ZM142.6,2963.9c-1.8,0-3.6-.5-5.2-1.6s-2.7-2.5-3.4-4.2-.9-3.6-.5-5.4,1.2-3.5,2.6-4.8c1.3-1.3,3-2.2,4.8-2.5,1.8-.4,3.7-.2,5.4.5s3.2,1.9,4.2,3.4,1.6,3.3,1.6,5.2-1,4.9-2.7,6.6-4.1,2.7-6.6,2.7h-.2Z" fill="#fff" />
          <path d="M142.6,2947.5v7h-7c0,1.4.4,2.7,1.2,3.9s1.9,2.1,3.1,2.6c1.3.5,2.7.7,4,.4,1.4-.3,2.6-.9,3.6-1.9s1.6-2.2,1.9-3.6c.3-1.4.1-2.8-.4-4-.5-1.3-1.4-2.4-2.6-3.1s-2.5-1.2-3.9-1.2h0Z" fill="#fff" />
        </g>
      </g>
    </g>
  </svg>
);

export const TyBase_Whotepe30 = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 298 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M154.5,312c0-6.6-5.4-12-12-12s-12,5.4-12,12,5.4,12,12,12v2c-7.7,0-14-6.3-14-14s6.3-14,14-14,14,6.3,14,14-6.3,14-14,14v-2c6.6,0,12-5.4,12-12Z" fill="#fff" />
      </g>
    </g>
  </svg>
);

export const Type = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3802 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M152,3814.4h-1.3v-5.9c0-.4-.2-.8-.4-1-.3-.3-.6-.4-1-.4h-5.9v-1.3c0-.7-.2-1.4-.7-2s-1.1-.9-1.8-1.1c-.8-.2-1.7,0-2.4.6s-1,1.4-1,2.3v1.5h-5.9c-.4,0-.8.2-1,.4-.3.3-.4.6-.4,1v5.2c0,.4.2.8.4,1,.3.3.6.4,1,.4h.7c.8,0,1.5.4,1.9,1.1.4.7.4,1.5,0,2.2s-1.1,1.1-1.9,1.1h-.7c-.4,0-.8.2-1,.4-.3.3-.4.6-.4,1v6.6c0,.4.2.8.4,1,.3.3.6.4,1,.4h5.2c.4,0,.8-.2,1-.4.3-.3.4-.6.4-1v-.7c0-.8.4-1.5,1.1-1.9.7-.4,1.5-.4,2.2,0s1.1,1.1,1.1,1.9v.7c0,.4.2.8.4,1,.3.3.6.4,1,.4h5.2c.4,0,.8-.2,1-.4.3-.2.4-.6.4-1v-7.4h1.5c.9,0,1.7-.4,2.3-1,.6-.7.8-1.6.6-2.4-.1-.7-.5-1.3-1.1-1.8-.5-.4-1.2-.7-2-.7v.2Z" />
  </svg>
);

export const Type131 = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1498 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M142,1512.3c3.5,0,6.4-2.9,6.4-6.4s-2.9-6.4-6.4-6.4-6.4,2.9-6.4,6.4,2.9,6.4,6.4,6.4Z" fill="#fff" />
      <path d="M143.6,1523.4c-1.2-1.3-2-3.1-2-5s.8-3.8,2-5.1h-1.8c-3.9,0-7.3,1-9.4,2.4-1.6,1.1-2.5,2.5-2.5,4v1.7c0,.5.2,1,.6,1.4.4.4.9.6,1.4.6h11.7Z" fill="#fff" fillRule="evenodd" />
      <path d="M149,1512.3c-3.4,0-6.1,2.8-6.1,6.1s2.7,6.1,6.1,6.1,6.1-2.7,6.1-6.1-2.7-6.1-6.1-6.1ZM146.2,1519.4l1.8,1.2c.3.2.8.2,1.1,0l2.9-2.9c.3-.3.3-.9,0-1.2-.3-.3-.9-.3-1.2,0l-2.4,2.4-1.2-.8c-.4-.3-.9-.2-1.2.2-.3.4-.2,1,.2,1.2h0Z" fill="#fff" fillRule="evenodd" />
    </g>
  </svg>
);

export const UnArchieve = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1690 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M147.5,1704c.4,0,.6.3.6.7v3.5c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-1.3c-1.4,1-2.2,2.5-2.2,4.2s.6,2.9,1.7,3.9c1.1,1,2.6,1.5,4.1,1.3,2.3-.2,4.3-2.1,4.6-4.4.4-2.5-1-4.8-3.3-5.7-.4-.2-.6-.6-.5-1,0-.2.2-.5.4-.6s.5,0,.7,0c2.7,1,4.5,3.7,4.5,6.6s-.8,3.7-2.2,5.1c-1.3,1.3-3,1.9-4.8,1.9s-.2,0-.3,0c-3.3-.2-6.2-2.8-6.6-6.1-.3-2.3.6-4.6,2.3-6.2h-.8c-.5,0-.9-.4-.9-.9s.4-.9.9-.9h3.6Z" />
          <path d="M154,1693.3c.5,0,1,.2,1.3.5s.5.8.5,1.3v4.6c0,.5-.2,1-.5,1.3s-.8.5-1.3.5h-1.2v1.1h-.2c-.8-.3-1.6-.2-2.4,0-.2,0-.4.3-.6.4-.5-.7-1.3-1.1-2.2-1.1h-3.5c-1.5,0-2.7,1.1-2.9,2.6v.6c0,.2,0,.4.1.5h-2.6c-.2,0-.5,0-.7.3-.2.2-.3.4-.3.7v.7c0,.2,0,.5.3.7.2.2.4.3.7.3h2.2c-.4,1.2-.5,2.6-.3,3.9.1.9.4,1.7.7,2.5h-7.1c-.6,0-1.1-.2-1.5-.6s-.6-.9-.6-1.5v-11.1h-1.2c-.5,0-1-.2-1.3-.5s-.5-.8-.5-1.3v-4.6c0-.5.2-1,.5-1.3.3-.4.8-.5,1.3-.5h23.3ZM131,1694.6c-.1,0-.3,0-.4.2,0,0-.2.2-.2.4v4.6c0,0,0,.3.2.4,0,0,.2.2.4.2h23c.1,0,.3,0,.4-.2,0,0,.2-.2.2-.4v-4.6c0,0,0-.3-.2-.4,0,0-.2-.2-.4-.2h-23Z" fillRule="evenodd" />
        </g>
      </g>
    </g>
  </svg>
);

export const User = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 538 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M142.5,552.1c3.7,0,6.8-3,6.8-6.8s-3-6.8-6.8-6.8-6.8,3-6.8,6.8,3,6.8,6.8,6.8Z" />
      <path d="M154.1,557.5c-.2-.4-.4-.9-.7-1.2-1.4-2-3.4-3.3-5.8-3.7-.3,0-.6,0-.9.2-1.2.9-2.7,1.4-4.2,1.4s-3-.5-4.2-1.4c-.2-.2-.6-.3-.9-.2-2.4.3-4.5,1.7-5.8,3.7-.3.4-.5.8-.7,1.2v.6c.2.4.5.8.8,1.2.4.6.9,1.1,1.4,1.5.4.4.9.8,1.4,1.2,2.3,1.7,5.1,2.7,8,2.7s5.7-.9,8-2.7c.5-.4.9-.8,1.4-1.2.5-.5.9-1,1.4-1.5.3-.4.6-.8.8-1.2.1-.2.2-.4,0-.6Z" />
    </g>
  </svg>
);

export const Walk = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3034 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M137.4,3061.5c.5,0,.9-.3,1.2-.7,0,0,2.1-4.3,2.8-5.6.2-.5.4-1.2.5-1.9-.4-.4-.9-.8-1.2-1-.1,0-.2-.2-.3-.2-.3-.2-.5-.4-.8-.6-.1.9-.3,2.1-.5,2.6-.6,1.3-2.7,5.6-2.8,5.6-.3.7,0,1.4.6,1.7.2.1.3.2.5.2h0Z" fill="#fff" />
      <path d="M149.7,3047.8c-.8-.6-2.1-1.8-2.4-2.3,0-.1-.2-.4-.3-.7-.6-1.2-1.6-3.5-4-3.5h-1.7c-2.6,0-4.4,2.4-4.8,3.2-.4.8-1.3,3.5-1.5,4.1-.2.5.2,1.1.7,1.2h.3c.4,0,.9-.3,1-.7.2-.5,1-3.1,1.3-3.8,0-.2.4-.7.9-1.1-.5,1.9-.3,4.5-.2,5.5,0,.7,1.3,1.4,2,1.9,1.2.8,2.9,2.6,3.3,3.4.3.6,1.5,4.1,2.1,5.6.2.5.7.8,1.2.8h.5c.7-.3,1-1,.7-1.7,0-.1-1.7-4.8-2.1-5.7-.3-.7-1.6-2.3-2.5-3.2h0c0-.5,0-3.8.5-6.1.2.3.3.6.5,1s.3.6.4.9c.6,1,2.5,2.5,2.9,2.8.2.2.4.2.6.2.3,0,.6-.1.8-.4.3-.4.3-1.1-.2-1.4Z" fill="#fff" />
      <path d="M142.2,3040.5c1.5,0,2.8-1.2,2.8-2.8s-1.2-2.8-2.8-2.8-2.8,1.2-2.8,2.8,1.2,2.8,2.8,2.8Z" fill="#fff" />
    </g>
  </svg>
);

export const Warning = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 1738 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path d="M142.5,1738c-2.8,0-5.5.8-7.8,2.4s-4.1,3.7-5.2,6.3c-1.1,2.6-1.3,5.4-.8,8.1s1.9,5.2,3.8,7.2c2,2,4.5,3.3,7.2,3.8s5.5.3,8.1-.8c2.6-1.1,4.7-2.9,6.3-5.2,1.5-2.3,2.4-5,2.4-7.8s-1.5-7.3-4.1-9.9-6.2-4.1-9.9-4.1ZM142.5,1760.4c-.4,0-.7,0-1-.3-.3-.2-.5-.5-.7-.8-.1-.3-.2-.7-.1-1.1,0-.4.2-.7.5-1s.6-.4,1-.5c.4,0,.7,0,1.1,0,.3,0,.6.4.8.7.2.3.3.7.3,1,0,.5-.2,1-.5,1.3s-.8.6-1.3.6h-.1ZM144.6,1745.9l-.6,7.5c0,.4-.2.7-.5,1-.3.2-.6.4-1,.4s-.7-.2-1-.4c-.3-.3-.5-.6-.5-1l-.6-7.5v-.9c0-.3.2-.5.4-.8.2-.2.4-.4.7-.5s.5-.2.8-.2.6,0,.9,0,.5.3.7.5.4.4.5.7.2.6.2.8v.2h0Z" fill="#f0a925" />
      </g>
    </g>
  </svg>
);

export const Warning_Stroke = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 826 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M142.5,854c-7.7,0-14-6.3-14-14s6.3-14,14-14,14,6.3,14,14-6.3,14-14,14ZM142.5,828.5c-6.3,0-11.5,5.1-11.5,11.5s5.1,11.5,11.5,11.5,11.5-5.1,11.5-11.5-5.1-11.5-11.5-11.5Z" />
          <path d="M142.5,848.1c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7,1.7.8,1.7,1.7-.8,1.7-1.7,1.7Z" />
          <path d="M142.5,842.1c-.7,0-1.3-.6-1.3-1.3v-7.6c0-.7.6-1.3,1.3-1.3s1.3.6,1.3,1.3v7.6c0,.7-.6,1.3-1.3,1.3Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Weather = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 3850 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M136.9,3861.7c.2-2.8,2.1-5.2,4.7-6.2-.7-.3-1.5-.5-2.2-.5-3.2,0-5.7,2.6-5.7,5.7s.2,1.7.6,2.5c.8-.7,1.7-1.2,2.8-1.5h-.2Z" />
          <path d="M150.8,3861.4h-.9c-.4-2.8-2.8-5-5.7-5s-5.7,2.6-5.7,5.7,0,.6,0,.8h0c-2.7,0-4.9,2.2-4.9,4.9s2.2,4.9,4.9,4.9h12.3c3.2,0,5.7-2.6,5.7-5.7s-2.6-5.8-5.7-5.8v.2Z" />
          <path d="M138.8,3874.7c-.4-.2-.9,0-1.1.4l-.8,1.7c-.2.4,0,.9.4,1.1h.4c.3,0,.6-.2.7-.5l.8-1.7c.2-.4,0-.9-.4-1.1h0Z" />
          <path d="M143,3874.7c-.4-.2-.9,0-1.1.4l-.8,1.7c-.2.4,0,.9.4,1.1h.4c.3,0,.6-.2.7-.5l.8-1.7c.2-.4,0-.9-.4-1.1h0Z" />
          <path d="M147.1,3874.7c-.4-.2-.9,0-1.1.4l-.8,1.7c-.2.4,0,.9.4,1.1h.4c.3,0,.6-.2.7-.5l.8-1.7c.2-.4,0-.9-.4-1.1h0Z" />
          <path d="M151.3,3874.7c-.4-.2-.9,0-1.1.4l-.8,1.7c-.2.4,0,.9.4,1.1h.4c.3,0,.6-.2.7-.5l.8-1.7c.2-.4,0-.9-.4-1.1h0Z" />
          <path d="M131.9,3860.6c0-.4-.4-.8-.8-.8h-1.6c-.5,0-.8.4-.8.8s.4.8.8.8h1.6c.5,0,.8-.4.8-.8Z" />
          <path d="M139.3,3849.9c-.5,0-.8.4-.8.8v1.7c0,.4.4.8.8.8s.8-.4.8-.8v-1.7c0-.5-.4-.8-.8-.8Z" />
          <path d="M135,3851.7c-.2-.4-.7-.5-1.1-.3-.4.2-.5.7-.3,1.1l.8,1.5c.2.3.4.4.7.4s.3,0,.4-.1c.4-.2.5-.7.3-1.1l-.8-1.5h0Z" />
          <path d="M130.3,3856.4l1.5.9c.1,0,.3.1.4.1.3,0,.6-.1.7-.4.2-.4,0-.9-.3-1.1l-1.5-.9c-.4-.2-.9,0-1.1.3-.2.4,0,.9.3,1.1h0Z" />
          <path d="M131.8,3864.1l-1.5.8c-.4.2-.5.7-.3,1.1.2.3.4.4.7.4s.3,0,.4-.1l1.5-.9c.4-.2.5-.7.3-1.1-.2-.4-.7-.5-1.1-.3h0Z" />
          <path d="M144.6,3851.3c-.4-.2-.9,0-1.1.3l-.8,1.5c-.2.4,0,.9.3,1.1.1,0,.3.1.4.1.3,0,.6-.2.7-.4l.8-1.5c.2-.4,0-.9-.3-1.1h0Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Wheelchair = ({ size = 24, color = 'currentColor', stroke = '#fff', strokeWidth = 0.1, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 4234 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M141,4256.1c-1.9-.3-3.5-1.9-3.7-3.8-.2-1.7.6-3.3,1.9-4.2.3-.2.4-.5.3-.8-.1-.6-.8-.9-1.3-.6-1.8,1.2-2.8,3.4-2.6,5.7.3,2.9,2.7,5.1,5.6,5.4,1.9.2,3.6-.5,4.9-1.7.2-.2.3-.5.2-.8-.1-.6-.9-.9-1.4-.5-1,.9-2.3,1.4-3.8,1.2h0Z" fill="#fff" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M149.5,4256.8l-1.2-6.4c0-.5-.5-.8-1-.8h-2.6l-.2-2.2h2.7c.5,0,.9-.4.9-.9s-.4-.8-.9-.8h-2.9v-.8c-.1-1-1-1.8-2-1.8h-.3c-.6,0-1.1.2-1.6.7-.4.4-.6,1-.5,1.6l.4,5.4c0,.5.5.9,1,.9h5l1,5.6c0,.5.5.8,1,.8s.1,0,.2,0c.5-.1.9-.6.8-1.2h.2Z" fill="#fff" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M142.2,4242.4c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2-2.2,1-2.2,2.2,1,2.2,2.2,2.2Z" fill="#fff" stroke={stroke} strokeWidth={strokeWidth} />
    </g>
  </svg>
);

export const Wheelchair_Blue = ({ size = 24, color = 'currentColor', stroke = '#fff', strokeWidth = 0.1, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 4186 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M128.5,4194c0-4.4,3.6-8,8-8h12c4.4,0,8,3.6,8,8v12c0,4.4-3.6,8-8,8h-12c-4.4,0-8-3.6-8-8v-12Z" fill="#454de8" />
      <path d="M141,4208.1c-1.9-.3-3.5-1.9-3.7-3.8-.2-1.7.6-3.3,1.9-4.2.3-.2.4-.5.3-.8-.1-.6-.8-.9-1.3-.6-1.8,1.2-2.8,3.4-2.6,5.7.3,2.9,2.7,5.1,5.6,5.4,1.9.2,3.6-.5,4.9-1.7.2-.2.3-.5.2-.8-.1-.6-.9-.9-1.4-.5-1,.9-2.3,1.4-3.8,1.2h0Z" fill="#fff" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M149.5,4208.8l-1.2-6.4c0-.5-.5-.8-1-.8h-2.6l-.2-2.2h2.7c.5,0,.9-.4.9-.9s-.4-.8-.9-.8h-2.9v-.8c-.1-1-1-1.8-2-1.8h-.3c-.6,0-1.1.2-1.6.7-.4.4-.6,1-.5,1.6l.4,5.4c0,.5.5.9,1,.9h5l1,5.6c0,.5.5.8,1,.8s.1,0,.2,0c.5-.1.9-.6.8-1.2h.2Z" fill="#fff" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M142.2,4194.4c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2-2.2,1-2.2,2.2,1,2.2,2.2,2.2Z" fill="#fff" stroke={stroke} strokeWidth={strokeWidth} />
    </g>
  </svg>
);

export const WheelchairInactive = ({ size = 24, color = 'currentColor', fill = '#b9bfc4', stroke = '#e8ebed', strokeWidth = 0.1, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 4282 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M153.2,4304.3c.4.4.4,1,0,1.4s-1,.4-1.4,0l-19-17c-.4-.4-.4-1,0-1.4s1-.4,1.4,0l19,17Z" fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
      <path d="M149.5,4305c0,.5-.4.9-.8,1h-.2c-.5,0-.9-.3-1-.8l-.4-2.4,2.4,2.2h0Z" fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
      <path d="M139.3,4295.9s-.1.2-.2.2c-1.3.9-2.1,2.5-1.9,4.2.3,1.9,1.8,3.5,3.7,3.8,1.5.2,2.9-.3,3.8-1.2.5-.5,1.3-.2,1.4.5,0,.3,0,.6-.2.8-1.2,1.2-3,1.9-4.9,1.7-2.9-.2-5.3-2.5-5.6-5.4-.3-2.3.8-4.5,2.5-5.7l1.2,1.1h.2Z" fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
      <path d="M143.4,4299.6h-2c-.5,0-.9-.4-1-.9l-.2-1.9,3.1,2.8h0Z" fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
      <path d="M147.3,4297.5c.5,0,.9.3,1,.8v.2l-1.2-1.1h.2Z" fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
      <path d="M142.4,4291c1,0,1.9.8,2,1.8v.8h2.9c.5,0,.9.4.9.8s-.4.9-.9.9h-2.6l-4.1-3.7c.4-.4.9-.6,1.5-.6h.3Z" fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
      <path d="M142.2,4286c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2-2.2-1-2.2-2.2,1-2.2,2.2-2.2Z" fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
    </g>
  </svg>
);

export const Workshop = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="128.5 2506 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M137.4,2518l1.7,1.7,3-3-1.7-1.7c.5-1.6,0-3.3-1.1-4.5-1.2-1.2-3-1.6-4.6-1.1-.2,0-.4.2-.4.4s0,.4.1.6l1.8,2.3-1,1-2.3-1.8c-.2-.1-.4-.2-.6-.1-.2,0-.4.2-.4.4-.5,1.6-.1,3.4,1.1,4.6,1.2,1.2,2.9,1.6,4.5,1.1h-.1Z" />
      <path d="M147.8,2522.4l-1.7-1.7-3,3,1.7,1.7c-.5,1.6,0,3.3,1.1,4.5.9.9,2,1.3,3.2,1.3s1,0,1.5-.2c.2,0,.4-.2.4-.4s0-.4-.1-.6l-1.8-2.3,1-1,2.3,1.8c.2.1.4.2.6.1s.4-.2.4-.4c.5-1.6.1-3.4-1.1-4.6-1.2-1.2-2.9-1.6-4.5-1.1h0Z" />
      <path d="M137.5,2523.1c-.3-.2-.7-.2-.9,0l-4.4,4.4c-.8.8-.8,2.2,0,3s2.2.8,3,0l4.4-4.4c.3-.2.3-.7,0-.9l-2.1-2.1Z" />
      <path d="M148.6,2519.6c.3.3.7.4,1.1.4s.8-.2,1.1-.4l2.4-2.4c.6-.6.6-1.5,0-2.1l-5.5-5.5c-.6-.6-1.5-.6-2.1,0l-2.4,2.4c-.6.6-.6,1.5,0,2.1l5.5,5.5h-.1Z" />
      <path d="M143.8,2516.8l-5.4,5.4,2.1,2.1,5.4-5.4-2.1-2.1Z" />
    </g>
  </svg>
);
